
import { useEffect, useRef, useState } from "react"

import { useDispatch, useSelector } from "react-redux";

import { useNavigate, useParams } from "react-router";

import { Box, Paper, Tabs, Tab, Grid, FormControl, InputLabel, Select, MenuItem, Button, TextField, Alert, Card, CardContent, CardHeader, Checkbox, Divider, FormControlLabel, FormLabel, Radio, RadioGroup, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Avatar, List } from "@mui/material"

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

import { DocumentEditorContainerComponent, CustomToolbarItemModel, ToolbarItem, Toolbar } from "@syncfusion/ej2-react-documenteditor";
import { DropDownButton, ItemModel } from "@syncfusion/ej2-react-splitbuttons";

import { DefaultDocumentEditor } from "../../../helpers/DefaultDocumentEditor";

import moment from 'moment';
import "moment/locale/es-mx";

import { RootState } from "../../../store";
import { openSnackbar } from "../../../store/slices/SnackbarSlice";

import { Layout } from "../../../components/Layout"
import { InfoField } from "../../../components/InfoField";
import { BoxProcesoCancelado } from "../../../components/BoxProcesoCancelado";
import { BoxProcesoTerminado } from "../../../components/BoxProcesoTerminado";
import { BoxHeaderInformacion } from "../../../components/BoxHeaderInformacion";
import { BoxInformacionAmparo } from "../../../components/BoxInformacionAmparo";
import { BoxProcesoNoEncontrado } from "../../../components/BoxProcesoNoEncontrado";
import { BoxInformacionPromocion } from "../../../components/BoxInformacionPromocion";
import { BoxInformacionIrregular } from "../../../components/BoxInformacionIrregular";
import { BoxInformacionExpediente } from "../../../components/BoxInformacionExpediente";
import { CircularProgressIndicator } from "../../../components/CircularProgressIndicator";
import { BoxInformacionExhortoRecibido } from "../../../components/BoxInformacionExhortoRecibido";

import { TabProps, TabPanel } from "../../../helpers/TabPanel"
import { FormatPhoneNumber } from "../../../helpers/FormatPhoneNumber";

import { Notificacion } from "../ui/Notificacion";

import { DialogDocumento } from "../../../dialogs/DialogDocumento";
import { DialogPartesAcuerdo } from "../../../dialogs/DialogPartesAcuerdo";

import { ObtenerEtapa } from "../../../connections/catalogos/EtapaConnection";
import { ObtenerSubEtapa } from "../../../connections/catalogos/SubEtapaConnection";
import { BuscarUsuarioPoderEnLinea } from "../../../connections/admin/UsuarioConnection";
import { ObtenerTipoAcuerdo } from "../../../connections/catalogos/TipoAcuerdoConnection";
import { ObtenerTipoRecurso } from "../../../connections/catalogos/TipoRecursoConnection";
import { ObtenerClaseExhorto } from "../../../connections/catalogos/ClaseExhortoConnection";
import { ObtenerSentidoFallo } from "../../../connections/catalogos/SentidoFalloConnection";
import { ObtenerObjetoExhorto } from "../../../connections/catalogos/ObjetoExhortoConnection";
import { ObtenerTipoAudiencias } from "../../../connections/catalogos/TipoAudienciaConnection";
import { ObtenerSubTipoAcuerdo } from "../../../connections/catalogos/SubTipoAcuerdoConnection";
import { ObtenerTipoResolucion } from "../../../connections/catalogos/TipoResolucionConnection";
import { ObtenerTipoRecurrente } from "../../../connections/catalogos/TipoRecurrenteConnection";
import { ObtenerPlantilla, ObtenerPlantillaDetalle } from "../../../connections/admin/PlantillaConnection";
import { ObtenerAutoridadResolutoria } from "../../../connections/catalogos/AutoridadResolutoriaConnection";
import { ObtenerCitacionSentenciaExpediente } from "../../../connections/sentencia/CitacionSentenciaConnection";
import { ObtenerAutoridadExhortoRecibido } from "../../../connections/catalogos/AutoridadExhortoRecibidoConnection";
import { ActualizarEstatus, DetalleAcuerdo, GuardarAcuerdo, ObtenerResoluciones } from "../../../connections/tribunal/AcuerdoConnection";
import { ObtenerMediosImpugnacion } from "../../../connections/tribunal/MedioImpugnacionConnection";

import { EtapaProps } from "../../../interfaces/catalogos/EtapaInterface";
import { SubEtapaProps } from "../../../interfaces/catalogos/SubEtapaInterface";
import { PlantillaDetalleProps } from "../../../interfaces/admin/PlantillaInterface";
import { TipoAcuerdoProps } from "../../../interfaces/catalogos/TipoAcuerdoInterface";
import { TipoRecursoProps } from "../../../interfaces/catalogos/TipoRecursoInterface";
import { SentidoFalloProps } from "../../../interfaces/catalogos/SentidoFalloInterface";
import { ClaseExhortoProps } from "../../../interfaces/catalogos/ClaseExhortoInterface";
import { TipoAudienciaProps } from "../../../interfaces/catalogos/TipoAudienciaInterface";
import { ObjetoExhortoProps } from "../../../interfaces/catalogos/ObjetoExhortoInterface";
import { SolicitarFechaAudiencia } from "../../../connections/audiencias/AgendaConnection";
import { SubTipoAcuerdoProps } from "../../../interfaces/catalogos/SubTipoAcuerdoInterface";
import { TipoResolucionProps } from "../../../interfaces/catalogos/TipoResolucionInterface";
import { TipoRecurrenteProps } from "../../../interfaces/catalogos/TipoRecurrenteInterface";
import { defaultTabValidation, TabValidationProps } from "../../../interfaces/ui/TabValidation";
import { CitacionSentenciaProps } from "../../../interfaces/sentencia/CitacionSentenciaInterface";
import { AutoridadResolutoriaProps } from "../../../interfaces/catalogos/AutoridadResolutoriaInterface";
import { AutoridadExhortoRecibidoProps } from "../../../interfaces/catalogos/AutoridadExhortoRecibidoInterface";
import { defaultUsuarioPoderEnLinea, UsuarioPoderEnLineaProps } from "../../../interfaces/admin/UsuarioInterface";
import { defaultFechaAudiencia, FechaAudienciaProps, SolicitarFechaAudienciaParams } from "../../../interfaces/audiencias/AgendaInterface";
import { AcuerdoProps, defaultAcuerdo, GuardarAcuerdoParams, UsuarioObservacionesProps } from '../../../interfaces/tribunal/AcuerdoInterface';
import { defaultMedioImpugnacion, MedioImpugnacionProps, MedioImpugnacionDocumentoProps } from '../../../interfaces/tribunal/MedioImpugnacionInterface';
import { NotificacionesProps } from "../../../interfaces/notificaciones/NotificacionesInterface";

DocumentEditorContainerComponent.Inject(Toolbar);

const defaultDocument = DefaultDocumentEditor();

interface ItemModelModif extends ItemModel {
    value?: string;
}

const acumulacion = false;
const edit = false;

const chipStyle = {
    display: 'flex', flexDirection: 'column', gap: 0.5,
    flex: 1,
    px: 2, py: 1,
    borderRadius: 1,
    backgroundColor: 'action.hover',
    border: '1px solid',
    borderColor: 'divider',
} as const;

export const ElaborarAcuerdoPage = () => {

    const dispatch = useDispatch();

    const { Id } = useParams();

    const { idUnidad } = useSelector( ( state: RootState ) => state.auth );

    const navigate = useNavigate();

    const syncfusionEditor = useRef<DocumentEditorContainerComponent | null>(null);
    const contenidoRef = useRef( '' );

    const dropCampos = useRef<DropDownButton>( null );

    const [value, setValue] = useState( 0 );

    const [editorReady, setEditorReady] = useState( false );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [loading, setLoading] = useState( true );
    const [loadingGuardar, setLoadingGuardar] = useState( false );
    const [loadingRegresar, setLoadingRegresar] = useState( false );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );
    const [loadingCuentaPL, setLoadingCuentaPL] = useState( false );

    const [openConfirmacion, setOpenConfirmacion] = useState( false );
    const [openPartesIrregular, setOpenPartesIrregular] = useState( false );

    const [tabValidation, setTabValidation] = useState<TabValidationProps>( defaultTabValidation );

    const [tipoAcuerdo, setTipoAcuerdo] = useState( 0 );
    const [tipoAcuerdoArray, setTipoAcuerdoArray] = useState<TipoAcuerdoProps[]>( [] );

    const [subTipoAcuerdo, setSubTipoAcuerdo] = useState( 0 );
    const [subTipoAcuerdoTemp, setSubTipoAcuerdoTemp] = useState( 0 );
    const [subTipoAcuerdoArray, setSubTipoAcuerdoArray] = useState<SubTipoAcuerdoProps[]>( [] );

    const [plantilla, setPlantilla] = useState( 0 );
    const [plantillaTemp, setPlantillaTemp] = useState( 0 );
    const [plantillaArray, setPlantillaArray] = useState<PlantillaDetalleProps[]>( [] );

    const [mecanografo, setMecanografo] = useState( 0 );

    const [autorizarExpedienteVirtual, setAutorizarExpedienteVirtual] = useState( false );
    const [archivoProvisional, setArchivoProvisional] = useState( false );

    const [cuentaPL, setCuentaPL] = useState( '' );
    const [usuarioPL, setUsuarioPL] = useState<UsuarioPoderEnLineaProps>( defaultUsuarioPoderEnLinea );

    const [tipoReservadoActor, setTipoReservadoActor] = useState( false );
    const [tipoReservadoDemandado, setTipoReservadoDemandado] = useState( false );

    const [observaciones, setObservaciones] = useState<UsuarioObservacionesProps[]>( [] );

    //-------------------------------- Información y catálogos del exhorto recibido ----------------------------------------------

    const [autoridadExhortoRecibido, setAutoridadExhortoRecibido] = useState( 0 );
    const [autoridadExhortoRecibidoArray, setAutoridadExhortoRecibidoArray] = useState<AutoridadExhortoRecibidoProps[]>( [] );

    const [claseExhorto, setClaseExhorto] = useState( 0 );
    const [claseExhortoArray, setClaseExhortoArray] = useState<ClaseExhortoProps[]>( [] );

    const [objetoExhorto, setObjetoExhorto] = useState( 0 );
    const [objetoExhortoArray, setObjetoExhortoArray] = useState<ObjetoExhortoProps[]>( [] );

    //----------------------------------------------------------------------------------------------------------------------------

    const [promocionIrregular, setPromocionIrregular] = useState( false );
    const [interponeIncidente, setInterponeIncidente] = useState( false );
    const [interponeRecurso, setInterponeRecurso] = useState( false );
    const [resuelveRecurso, setResuelveRecurso] = useState( false );

    const [enviarPromocion, setEnviarPromocion] = useState( false );

    //----------------------------------------------------------------------------------------------------------------------------

    const [openDialogSolicitarFechaAudiencia, setOpenDialogSolicitarFechaAudiencia] = useState( false );
    const [loadingSolicitarFechaAudiencia, setLoadingSolicitarFechaAudiencia] = useState( false );
    const [solicitarFechaAudiencia, setSolicitarFechaAudiencia] = useState( false );
    const [audiencia, setAudiencia] = useState<FechaAudienciaProps>( defaultFechaAudiencia );

    const [tipoAudiencia, setTipoAudiencia] = useState( 0 );
    const [tipoAudienciaArray, setTipoAudienciaArray] = useState<TipoAudienciaProps[]>( [] );
    const [duracionAudiencia, setDuracionAudiencia] = useState( 0 );
    const [agregarDuracion, setAgregarDuracion] = useState( false );

    //--------------------------------------------------------------------------------------------------------------------------------------------

    const [medioImpugnacion, setMedioImpugnacion] = useState<MedioImpugnacionProps>( defaultMedioImpugnacion );

    const [tipoRecursoArray, setTipoRecursoArray] = useState<TipoRecursoProps[]>( [] );
    const [autoridadResolutoriaArray, setAutoridadResolutoriaArray] = useState<AutoridadResolutoriaProps[]>( [] );
    const [tipoResolucionArray, setTipoResolucionArray] = useState<TipoResolucionProps[]>( [] );
    const [tipoRecurrenteArray, setTipoRecurrenteArray] = useState<TipoRecurrenteProps[]>( [] );

    const [openResoluciones, setOpenResoluciones] = useState( false );
    const [resoluciones, setResoluciones] = useState<MedioImpugnacionDocumentoProps[]>( [] );

    const [medioImpugnacionSelected, setMedioImpugnacionSelected] = useState( 0 );
    const [medioImpugnacionSelectedTemp, setMedioImpugnacionSelectedTemp] = useState( 0 );
    const [medioImpugnacionArray, setMedioImpugnacionArray] = useState<MedioImpugnacionProps[]>( [] );

    const [fechaRemisionAlzada, setFechaRemisionAlzada] = useState( moment( new Date() ).format( 'YYYY-MM-DD' ) );

    const [sentidoFallo, setSentidoFallo] = useState( 0 );
    const [sentidoFalloArray, setSentidoFalloArray] = useState<SentidoFalloProps[]>( [] );

    const [fechaDevolucionAlzada, setFechaDevolucionAlzada] = useState( moment( new Date() ).format( 'YYYY-MM-DD' ) );

    const { idTipoRecurso, tipoRecurso, idAutoridadResolutoria, idTipoResolucion, tipoResolucion,
        idTipoRecurrente, idParte, recurrente, medioImpugnacionDocumento, fechaAdmision } = medioImpugnacion;

    //--------------------------------------------------------------------------------------------------------------------------------------------

    const [etapa, setEtapa] = useState( 0 );
    const [etapaArray, setEtapaArray] = useState<EtapaProps[]>( [] );

    const [subEtapa, setSubEtapa] = useState( 0 );
    const [subEtapaTemp, setSubEtapaTemp] = useState( 0 );
    const [subEtapaArray, setSubEtapaArray] = useState<SubEtapaProps[]>( [] );

    //--------------------------------------------------------------------------------------------------------------------------------------------

    const [fechaResolucion, setFechaResolucion] = useState( moment( new Date() ).format( 'YYYY-MM-DD' ) );

    //--------------------------------------------------------------------------------------------------------------------------------------------

    const [openDocumento, setOpenDocumento] = useState( false );
    const [documento, setDocumento] = useState( '' );

    //----------------------------------------------------------------------------------------------

    const [tipoSentencia, setTipoSentencia] = useState( 0 );
    const [citaSentencia, setCitaSentencia] = useState( false );

    const [citacionSentencia, setCitacionSentencia] = useState( 0 );
    const [citacionSentenciaTemp, setCitacionSentenciaTemp] = useState( 0 );
    const [citacionSentenciaArray, setCitacionSentenciaArray] = useState<CitacionSentenciaProps[]>( [] );

    //----------------------------------------------------------------------------------------------

    const [acuerdo, setAcuerdo] = useState<AcuerdoProps>( defaultAcuerdo );
    const [notificaciones, setNotificaciones] = useState<NotificacionesProps[]>( [] );

    let Toolbar: ( CustomToolbarItemModel | ToolbarItem )[] = [
        'New',
        'Open',
        'Separator',
        'Undo',
        'Redo',
        'Separator',
        'Image',
        'Table',
        'Separator',
        'Header',
        'Footer',
        'Separator',
        {
            tooltipText: 'Atajos',
            text: 'Atajos',
            id: 'dropItem',
            prefixIcon: "e-icons e-drop-down",
        }
    ];

    const handleChange = (_: React.SyntheticEvent, newValue: number) => {

        if ( value === 0 && newValue !== 0 ) {

            const serialized = syncfusionEditor.current?.documentEditor.serialize() ?? '';

            contenidoRef.current = serialized;
            setEditorReady( false );
        }

        setValue(newValue);
    }

    const validateFields = () => {

        let valid = true;

        if ( tipoAcuerdo === 0 ) {

            dispatch( openSnackbar({ message: 'Debes seleccionar el tipo de acuerdo', variant: 'warning' }));
            valid = false;

        }

        if (  tipoAcuerdo !== 0 && subTipoAcuerdo === 0 && subTipoAcuerdoArray.length !== 0 ) {

            dispatch( openSnackbar({ message: 'Debes seleccionar el subtipo de acuerdo', variant: 'warning' }));
            valid = false;

        }

        if (  mecanografo === 0 ) {

            dispatch( openSnackbar({ message: 'Debes seleccionar un usuario para elaborar el acuerdo', variant: 'warning' }));
            valid = false;

        }

        if (  autorizarExpedienteVirtual || tipoAcuerdo === 16 ) {

            if (  usuarioPL.correoElectronico === '' ) {

                dispatch( openSnackbar({ message: 'Debes buscar el solicitante para autorizar el expediente virtual', variant: 'warning' }));
                valid = false;

            }

        }

        if (  tipoAcuerdo === 21 && medioImpugnacionSelected === 0 ) {

            dispatch( openSnackbar({ message: 'Debes seleccionar un recurso', variant: 'warning' }));
            valid = false;

        }

        if (  ( tipoAcuerdo === 10 || citaSentencia ) && tipoSentencia === 0 ) {

            dispatch( openSnackbar({ message: 'Debes seleccionar un tipo de sentencia', variant: 'warning' }));
            valid = false;

        }

        if (  tipoAcuerdo === 11 && citacionSentencia === 0 ) {

            dispatch( openSnackbar({ message: 'Debes seleccionar la citación de sentencia', variant: 'warning' }));
            valid = false;

        }

        if (  citaSentencia && tipoSentencia === 0 ) {

            dispatch( openSnackbar({ message: 'Debes seleccionar el tipo de sentencia', variant: 'warning' }));
            valid = false;

        }

        if (  solicitarFechaAudiencia && tipoAudiencia === 0 ) {

            dispatch( openSnackbar({ message: 'Debes seleccionar el tipo de audiencia', variant: 'warning' }));
            valid = false;

        }

        if (  solicitarFechaAudiencia && tipoAudiencia !== 0 && audiencia.idTipoAudiencia === 0 ) {

            dispatch( openSnackbar({ message: 'Debes solicitar una fecha de audiencia', variant: 'warning' }));
            valid = false;

        }

        return valid;
    }

    const Guardar = async () => {

        const tipoReservado = ( tipoReservadoActor && tipoReservadoDemandado ) ? 3 : tipoReservadoActor ? 1 : tipoReservadoDemandado ? 2 : 0;

        const serialized = syncfusionEditor.current?.documentEditor.serialize() ?? '';

        const params: GuardarAcuerdoParams = {
            id: Id ?? '',
            idTipoAcuerdo: tipoAcuerdo,
            idSubTipoAcuerdo: subTipoAcuerdo,
            idTipoReservado: tipoReservado,
            idUsuarioElaboro: mecanografo,
            idPlantilla: plantilla,
            usuarioPoderEnLinea: usuarioPL,
            autorizarExpedienteVirtual,
            archivoProvisional,
            enviarPromocion,
            observaciones: '',
            contenido: serialized,
            idAutoridadExhortoRecibido: autoridadExhortoRecibido,
            idObjetoExhorto: objetoExhorto,
            idClaseExhorto: claseExhorto,
            promocionIrregular,
            interponeIncidente,
            interponeRecurso,
            resuelveRecurso,
            medioImpugnacion,
            idMedioImpugnacion: medioImpugnacionSelected,
            fechaRemisionAlzada: tipoAcuerdo === 21 ? fechaRemisionAlzada : '',
            idSentidoFallo: sentidoFallo,
            fechaDevolucionAlzada: resuelveRecurso ? fechaDevolucionAlzada : '',
            idEtapa: etapa,
            idSubEtapa: subEtapa,
            fechaResolucionAmparo: fechaResolucion,
            idTipoSentencia: tipoSentencia,
            idCitacionSentencia: citacionSentencia,
            citaSentencia,
            solicitarFechaAudiencia,
        };

        contenidoRef.current = serialized;

        return await GuardarAcuerdo( params );
    }

    const handleGuardar = async () => {

        const validate = validateFields();

        if (  !validate ) return;

        setLoadingGuardar( true );

        await Guardar().then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if (  success ) {

                    setLoadingGuardar( false );

                    dispatch( openSnackbar({ message: message, variant: 'success' }));

                }
                else {

                    setLoadingGuardar( false );

                    dispatch( openSnackbar({ message: message, variant: 'error' }));

                }

            }, 700);

        });

    }

    const handleFinalizar = async () => {

        const validate = validateFields();

        if (  !validate ) return;

        setLoadingFinalizar( true );

        const { success: successGuardar, message: messageGuardar } = await Guardar();

        if (  !successGuardar ) {

            setTimeout(() => {

                dispatch( openSnackbar({ message: messageGuardar, variant: 'error' }));

                setLoadingFinalizar( false );

            }, 700);

            return;

        }

        await ActualizarEstatus({ id: Id ?? '', idEstatus: 25 }).then( resp => {

            setTimeout(() => {

                const { success, message, asignadoMismoUsuario, usuarioAsignado } = resp;

                if (  success ) {

                    if (  asignadoMismoUsuario ) {

                        navigate(`/tribunal/acuerdo/validar/${ Id ?? '' }`);

                    }
                    else{

                        if (  !asignadoMismoUsuario ) {

                            setMensajeAsignacion( `La siguiente actividad se asignó a ${ usuarioAsignado }` );
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else {

                            setMensajeAsignacion( 'La siguiente actividad se encuentra en tu bandeja' );
                            setProcesoTerminado( true );
                            setLoading( false );

                        }

                    }

                    setLoadingFinalizar( false );
                    setOpenConfirmacion( false );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));
                    setLoadingFinalizar( false );

                }

            }, 700);

        });

    }

    const handleRegresar = async () => {

        setLoadingRegresar( true );

        const { success: successGuardar, message: messageGuardar } = await Guardar();

        if (  !successGuardar ) {

            setTimeout(() => {

                dispatch( openSnackbar({ message: messageGuardar, variant: 'error' }));

                setLoadingRegresar( false );

            }, 700);

        }

        await ActualizarEstatus({ id: Id ?? '', idEstatus: 23 }).then( resp => {

            setTimeout(() => {

                const { success, message, asignadoMismoUsuario, usuarioAsignado } = resp;

                if (  success ) {

                    if (  asignadoMismoUsuario ) {

                        navigate(`/tribunal/acuerdo/calificar-tramite/${ Id ?? '' }`);

                    }
                    else{

                        if (  !asignadoMismoUsuario ) {

                            setMensajeAsignacion( `La siguiente actividad se asignó a ${ usuarioAsignado }` );
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else {

                            setMensajeAsignacion( 'La siguiente actividad se encuentra en tu bandeja' );
                            setProcesoTerminado( true );
                            setLoading( false );

                        }

                    }

                    setLoadingRegresar( false );
                    setOpenConfirmacion( false );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));
                    setLoadingRegresar( false );

                }

            }, 700);

        });

    }

    const handleSolicitarFechaAudiencia = async () => {

        setLoadingSolicitarFechaAudiencia( true );

        const params: SolicitarFechaAudienciaParams = {
            idAcuerdo: acuerdo.idAcuerdo,
            idAudiencia: 0,
            idTipoAcuerdo: tipoAcuerdo,
            idSubTipoAcuerdo: subTipoAcuerdo,
            idTipoAudiencia: tipoAudiencia,
            duracion: agregarDuracion ? duracionAudiencia : 0,
        };

        const tipoAudienciaDescripcion = tipoAudienciaArray.find( ({ idTipoAudiencia }) => idTipoAudiencia === tipoAudiencia  )?.descripcion ?? '';

        await SolicitarFechaAudiencia( params ).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if (  success ) {

                    setSolicitarFechaAudiencia( true );
                    setAudiencia({
                        ...resp,
                        idTipoAudiencia: tipoAudiencia,
                        tipoAudiencia: tipoAudienciaDescripcion,
                        duracion: agregarDuracion ? duracionAudiencia : 0,
                    });

                    setLoadingSolicitarFechaAudiencia( false );
                    setOpenDialogSolicitarFechaAudiencia( false );
                    setOpenPartesIrregular( false );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));
                    setLoadingSolicitarFechaAudiencia( false );

                }

            }, 700);

        });

    }

    const handleBuscarUsuarioPoderEnLinea = async() => {

        const isEmail = cuentaPL.includes('@');

        setLoadingCuentaPL( true );

        await BuscarUsuarioPoderEnLinea({
            correoElectronico: isEmail ? cuentaPL : '',
            telefonoCelular: !isEmail ? FormatPhoneNumber( cuentaPL ) : '',
        }).then( resp => {

            setTimeout(() => {

                setCuentaPL( '' );
                setUsuarioPL( resp );
                setLoadingCuentaPL( false );

            }, 700);

        });

    }

    const handleChangeTipoAcuerdo = ( value: number) => {

        if (  value !== 16 ) {
            setUsuarioPL( defaultUsuarioPoderEnLinea );
            setCuentaPL( '' );
        }

        setSolicitarFechaAudiencia( false );
        setTipoAudiencia(0);
        setAgregarDuracion( false );

        setCitaSentencia( false );
        setTipoSentencia( 0 );

        setSubTipoAcuerdo( 0 );
        setSubTipoAcuerdoTemp( 0 );
        setSubTipoAcuerdoArray( [] );
        setTipoAcuerdo( value );
    }

    const handleConfirmacion = () => {

        const validate = validateFields();

        if (  !validate ) return;

        setOpenConfirmacion( true );
    }

    const handleChangeResulveRecurso = ( value: boolean ) => {

        setPromocionIrregular( false );
        setInterponeIncidente( false );
        setInterponeRecurso( false );

        setResuelveRecurso( value );

    }

    //---------------------------------------------- funciones para plantilla ----------------------------------------------------------

    const obtenerPlantilla = async ( id: number ) => {

        setPlantilla( id );

        await ObtenerPlantillaDetalle( id ).then( resp => {

            const { idPlantilla, contenido, } = resp;

            if ( idPlantilla !== 0 ) {

                if ( !( /<\/?[a-z][\s\S]*>/.test(contenido) ) ) {

                    const contentSetValues = reemplaceData( contenido );

                    syncfusionEditor.current?.documentEditor.open( contentSetValues );

                }
                else if (  /<\/?[a-z][\s\S]*>/.test(contenido) ) {

                    const contenidoParser = contenido.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').replace(/&/g, "").replace(/acute;/g, "") ?? "";

                    const contentSetValues = reemplaceData( contenidoParser );

                    syncfusionEditor.current?.documentEditor.open( defaultDocument );

                    syncfusionEditor.current?.documentEditor.editor.insertText( contentSetValues );
                }
                else {
                    syncfusionEditor.current?.documentEditor.open( defaultDocument );
                }

            }

        });

    }

    const reemplaceData = ( contenido: string )  => {

        const { expediente, amparo, exhortoRecibido, irregular } = acuerdo;

        if (expediente.idExpediente !== 0 && amparo.idAmparo === 0) {

            return contenido
                .replaceAll('[Actor]',             expediente.actores.join(', '))
                .replaceAll('[Demandado]',         expediente.demandados.join(', '))
                .replaceAll('[Tipo_Juicio]',       expediente.tipoJuicio ?? '')
                .replaceAll('[Numero_Expediente]', expediente.numeroExpediente ?? '');
        }

        if ( exhortoRecibido.idExhortoRecibido !== 0 ) {

            return contenido
                .replaceAll('[Actor]',             exhortoRecibido.actores.join(', '))
                .replaceAll('[Demandado]',         exhortoRecibido.demandados.join(', '))
                .replaceAll('[Tipo_Juicio]',       exhortoRecibido.tipoJuicio ?? '')
                .replaceAll('[Numero_Origen]',     exhortoRecibido.numeroExpedienteOrigen ?? '')
                .replaceAll('[Numero_Exhorto]',    exhortoRecibido.numeroExhorto ?? '')
                .replaceAll('[Autoridad_Exhorto]', exhortoRecibido.autoridadExhortoRecibido ?? '');
        }

        if ( irregular.idIrregular !== 0 ) {

            return contenido
                .replaceAll('[Actor]',            irregular.actores.join(', '))
                .replaceAll('[Demandado]',        irregular.demandados.join(', '))
                .replaceAll('[Numero_Irregular]', irregular.numeroIrregular ?? '');
        }

        if ( amparo.idAmparo !== 0 ) {
            const partes = amparo.partes
                .map(({ persona, tipoParte }) => `${persona} (${tipoParte})`)
                .join(', ');

            return contenido
                .replaceAll('[Numero_Amparo]',     amparo.numeroAmparo ?? '')
                .replaceAll('[Numero_Expediente]', expediente.numeroExpediente ?? '')
                .replaceAll('[Tipo_Juicio]',       expediente.tipoJuicio ?? '')
                .replaceAll('[Autoridad_Amparo]',  amparo.autoridadAmparo ?? '')
                .replaceAll('[Tipo_Amparo]',       amparo.tipoAmparo ?? '')
                .replaceAll('[Partes_Amparo]',     partes);
        }

        return contenido;
    }

    //--------------------------------------------- funciones para el editor de text --------------------------------------------------

    const handleEditorCreated = () => {
        setEditorReady( true );
    };

    useEffect(() => {

        if ( value === 0 && !loading && editorReady && syncfusionEditor.current ) {

            syncfusionEditor.current.documentEditor.open( contenidoRef.current || DefaultDocumentEditor() );
            syncfusionEditor.current.documentEditorSettings.showRuler = true;
            syncfusionEditor.current.documentEditor.pageOutline = '#D0D0D0';

            dropCampos.current?.appendTo('#dropItem');

        }

    }, [ value, loading, editorReady ]);

    //----------------------------------------------------------------------------------------------------------------------------------

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoAcuerdo().then( resp => {
                setTipoAcuerdoArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            setSubTipoAcuerdo( 0 );
            setSubTipoAcuerdoArray( [] );

            await ObtenerSubTipoAcuerdo( tipoAcuerdo ).then( resp => {
                setSubTipoAcuerdoArray( resp );
            });

        }

        Obtener();

    }, [ tipoAcuerdo ])

    useEffect(() => {

        async function Obtener() {

            setPlantilla( 0 );
            setPlantillaArray( [] );

            if ( tipoAcuerdo !== 0 ) {

                await ObtenerPlantilla({
                    idTipoAcuerdo: tipoAcuerdo,
                    idSubTipoAcuerdo: subTipoAcuerdo,
                    idTipoNotificacion: 0,
                    idAutoridad: 0
                }).then( resp => {
                    setPlantillaArray( resp );

                });
            }

        }

        Obtener();

    }, [ tipoAcuerdo, subTipoAcuerdo ])

    useEffect(() => {

        async function Obtener() {

            await ObtenerAutoridadExhortoRecibido().then( resp => {
                setAutoridadExhortoRecibidoArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerClaseExhorto().then( resp => {
                setClaseExhortoArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerObjetoExhorto().then( resp => {
                setObjetoExhortoArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoAudiencias().then( resp => {
                setTipoAudienciaArray( resp );
            });

        }

        Obtener();

    }, [])

    //--------------------------------------------------------------------------------------------------------------------------------------------

    useEffect(() => {

        async function Obtener() {

            await ObtenerEtapa().then( resp => {
                setEtapaArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            setSubEtapa( 0 );
            setSubEtapaArray( [] );

            await ObtenerSubEtapa( etapa ).then( resp => {
                setSubEtapaArray( resp );
            });

        }

        if (  etapa !== 0 ) {
            Obtener();
        }

    }, [ etapa ])

    //--------------------------------------------------------------------------------------------------------------------------------------------

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoRecurso().then( resp => {
                setTipoRecursoArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerAutoridadResolutoria().then( resp => {
                setAutoridadResolutoriaArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoResolucion().then( resp => {
                setTipoResolucionArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoRecurrente().then( resp => {
                setTipoRecurrenteArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerSentidoFallo().then( resp => {
                setSentidoFalloArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            const idTipoSentencia = idTipoResolucion === 2 ? 1 : idTipoResolucion === 3 ? 2 : 0;

            await ObtenerResoluciones({
                idTipoResolucion,
                idExpediente: tabValidation.idExpediente,
                idTipoSentencia
            }).then( resp => {

                setResoluciones( resp );

            });

        }

        if (  openResoluciones && idTipoResolucion !== 0 && tabValidation.idExpediente !== 0 ) {
            Obtener();
        }

    }, [ openResoluciones, idTipoResolucion, tabValidation.idExpediente ])

    useEffect(() => {

       async function Obtener() {

            const idEstatus = tipoAcuerdo === 21 ? 19 : resuelveRecurso ? 20 : 0;

            await ObtenerMediosImpugnacion({
                idExpediente: tabValidation.idExpediente,
                idEstatus
            }).then( resp => {

                setMedioImpugnacionArray( resp );

            });

        }

        if (  ( tipoAcuerdo !== 0 || resuelveRecurso ) && tabValidation.idExpediente !== 0 ) {
            Obtener();
        }

    }, [ tipoAcuerdo, resuelveRecurso, tabValidation.idExpediente ])

    useEffect(() => {

        if (  medioImpugnacionSelectedTemp !== 0 && medioImpugnacionArray.length !== 0 ) {
            setMedioImpugnacionSelected( medioImpugnacionSelectedTemp );
        }

    }, [ medioImpugnacionSelectedTemp, medioImpugnacionArray.length ])

    //--------------------------------------------------------------------------------------------------------------------------------------------

    useEffect(() => {

        async function Obtener() {

            setCitacionSentencia( 0 );
            setCitacionSentenciaArray( [] );

            await ObtenerCitacionSentenciaExpediente( tabValidation.idExpediente ).then( resp => {
                setCitacionSentenciaArray( resp );
            });

        }

        if (  tabValidation.idExpediente !== 0 && tipoAcuerdo === 11 ) {
            Obtener();
        }

    }, [ tabValidation.idExpediente, tipoAcuerdo ])

    useEffect(() => {

        if (  citacionSentenciaTemp !== 0 && citacionSentenciaArray.length !== 0 ) {
            setCitacionSentencia( citacionSentenciaTemp );
        }

    }, [ citacionSentenciaTemp, citacionSentenciaArray.length ])

    //--------------------------------------------------------------------------------------------------------------------------------------------

    useEffect(() => {

        async function Obtener() {

            await DetalleAcuerdo( Id ?? '' ).then( resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if (  success ) {

                        setAcuerdo( resp );

                        setTabValidation({
                            idAmparo: resp.idAmparo,
                            idDemandaInicial: resp.idDemandaInicial,
                            idExhortoRecibido: resp.idExhortoRecibido,
                            idExpediente: resp.idExpediente,
                            idIrregular: resp.idIrregular,
                            idPromocion: resp.idPromocion,
                        });

                        setTipoAcuerdo( resp.idTipoAcuerdo );
                        setSubTipoAcuerdoTemp( resp.idSubTipoAcuerdo );
                        setMecanografo( resp.idUsuarioElaboro );
                        setObservaciones( resp.usuarioObservaciones );

                        contenidoRef.current = resp.contenido;

                        setNotificaciones( resp.notificaciones );

                        const mkItem = ( text: string, id: string, value: string ): ItemModelModif[] =>
                            [{ text, id, iconCss: 'e-icons e-bookmark', value }, { separator: true }];
                        const joinNames = ( arr: string[] ) => arr.join(', ');

                        let items: ItemModelModif[] = [
                            ...mkItem('Fecha Actual', '1', '[Fecha_Actual]'),
                        ];

                        if ( resp.idExpediente !== 0 && resp.idAmparo === 0 ) {

                            const { expediente: e } = resp;

                            items.push(
                                ...mkItem('Número de Expediente', '2', e.numeroExpediente),
                                ...mkItem('Tipo de Juicio', '3', e.tipoJuicio),
                                ...mkItem('Juzgado Origen', '4', e.juzgadoOrigen),
                                ...mkItem('Actor(es)', '5', joinNames( e.actores )),
                                ...mkItem('Demandado(s)', '6', joinNames( e.demandados )),
                                ...mkItem('Juez', '7', e.juez),
                            );

                            if ( e.numeroFolio ) items.push(...mkItem('Número de Folio', '8', e.numeroFolio));
                            if ( e.secretario )  items.push(...mkItem('Secretario', '9', e.secretario));

                        }

                        if ( resp.idExhortoRecibido !== 0 ) {

                            const { exhortoRecibido: ex } = resp;

                            items.push(
                                ...mkItem('Número de Exhorto', '10', ex.numeroExhorto),
                                ...mkItem('Número de Expediente Origen', '11', ex.numeroExpedienteOrigen),
                                ...mkItem('Tipo de Juicio', '12', ex.tipoJuicio),
                                ...mkItem('Autoridad del Exhorto', '13', ex.autoridadExhortoRecibido),
                                ...mkItem('Actor(es)', '14', joinNames( ex.actores )),
                                ...mkItem('Demandado(s)', '15', joinNames( ex.demandados )),
                            );

                        }

                        if ( resp.idIrregular !== 0 ) {

                            const { irregular: ir } = resp;

                            items.push(
                                ...mkItem('Número Irregular', '16', ir.numeroIrregular),
                                ...mkItem('Actor(es)', '17', joinNames( ir.actores )),
                                ...mkItem('Demandado(s)', '18', joinNames( ir.demandados )),
                            );

                        }

                        if ( resp.idAmparo !== 0 ) {

                            const { amparo: am } = resp;
                            const cadenaPartes = am.partes.map( ({ persona, tipoParte }) => `${ persona } (${ tipoParte })` ).join(', ');

                            items.push(
                                ...mkItem('Número de Amparo', '19', am.numeroAmparo),
                                ...mkItem('Autoridad del Amparo', '20', am.autoridadAmparo),
                                ...mkItem('Tipo de Amparo', '21', am.tipoAmparo),
                                ...mkItem('Partes del Amparo', '22', cadenaPartes),
                            );

                        }

                        if ( items[items.length - 1]?.separator ) { items.pop(); }

                        dropCampos.current = new DropDownButton({
                            items: items,
                            beforeItemRender: (data: ItemModelModif) => {
                                return `<div>
                                            <span class="e-menu-icon ${data.iconCss}"></span>
                                            <span class="custom-class" >${data.text}</span>
                                        </div>`;
                            },
                            select: (args) => syncfusionEditor.current?.documentEditor.editor.insertText( args?.item.value ?? "" ),
                        },);

                        setAutorizarExpedienteVirtual( resp.autorizarExpedienteVirtual );
                        setUsuarioPL( resp.usuarioPoderEnLinea );

                        setArchivoProvisional( resp.archivoProvisional );
                        setEnviarPromocion( resp.enviarPromocion );
                        setPlantillaTemp( resp.idPlantilla );

                        setTipoReservadoActor( [1, 3].includes( resp.idTipoReservado ) );
                        setTipoReservadoDemandado( [2, 3].includes( resp.idTipoReservado ) );

                        setPromocionIrregular( resp.promocionIrregular );

                        setInterponeIncidente( resp.interponeIncidente );
                        setInterponeRecurso( resp.interponeRecurso );
                        setResuelveRecurso( resp.resuelveRecurso );

                        setSolicitarFechaAudiencia( resp.solicitarFechaAudiencia );
                        setAudiencia( resp.audiencia );
                        setTipoAudiencia( resp.audiencia.idTipoAudiencia );
                        setDuracionAudiencia( resp.audiencia.duracion );
                        setAgregarDuracion( resp.audiencia.duracion !== 0 );

                        setMedioImpugnacion( resp.medioImpugnacion );

                        setMedioImpugnacionSelectedTemp( resp.idMedioImpugnacion );
                        setFechaRemisionAlzada( moment( resp.fechaRemisionAlzada ?? new Date() ).format('YYYY-MM-DD') );

                        setSentidoFallo( resp.idSentidoFallo );
                        setFechaDevolucionAlzada( moment( resp.fechaDevolucionAlzada ?? new Date() ).format('YYYY-MM-DD') );

                        setEtapa( resp.idEtapa );
                        setSubEtapaTemp( resp.idSubEtapa );

                        setFechaResolucion( moment( resp.fechaResolucionAmparo ?? new Date() ).format('YYYY-MM-DD') );

                        setTipoSentencia( resp.idTipoSentencia );
                        setCitaSentencia( resp.citaSentencia );
                        setCitacionSentenciaTemp( resp.idCitacionSentencia );

                        if (  resp.idPromocion === 0 && resp.idExhortoRecibido !== 0 ) {

                            setAutoridadExhortoRecibido( resp.exhortoRecibido.idAutoridadExhortoRecibido );
                            setObjetoExhorto( resp.exhortoRecibido.idObjetoExhorto );
                            setClaseExhorto( resp.exhortoRecibido.idClaseExhorto );

                        }

                        if (  resp.idEstatus === 3 ) {
                            setMensajeFinalizacion( 'No se tienen actividades pendientes para este trámite' );
                            setProcesoTerminado( true );
                            setLoading(false);
                        }
                        else if (  resp.idEstatus === 4 ) {
                            setProcesoCancelado( true );
                            setLoading(false);
                        }
                        else if (  !resp.asignadoMismoUsuario ) {
                            setMensajeAsignacion( `La siguiente actividad se asignó a ${ resp.usuarioAsignado }` );
                            setProcesoTerminado( true );
                            setLoading(false);
                        }
                        else if (  resp.asignadoMismoUsuario && resp.idEstatus !== 24 ) {
                            setMensajeAsignacion( 'La siguiente actividad se encuentra en tu bandeja' );
                            setProcesoTerminado( true );
                            setLoading(false);
                        }
                        else if (  resp.asignadoMismoUsuario && resp.idEstatus === 24 ) {
                            setLoading(false);
                        }
                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });
        }

        if (  Id ) {
            Obtener();
        }

    }, [ Id ])

    useEffect(() => {

        if (  subTipoAcuerdoTemp !== 0 && subTipoAcuerdoArray.length !== 0 ) {
            setSubTipoAcuerdo( subTipoAcuerdoTemp );
        }

    }, [ subTipoAcuerdoTemp, subTipoAcuerdoArray.length ])

    useEffect(() => {

        if (  plantillaTemp !== 0 && plantillaArray.length !== 0 ) {
            setPlantilla( plantillaTemp );
        }

    }, [ plantillaTemp, plantillaArray.length ])

    useEffect(() => {

        if (  subEtapaTemp !== 0 && subEtapaArray.length !== 0 ) {
            setSubEtapa( subEtapaTemp );
        }

    }, [ subEtapaTemp, subEtapaArray.length ])

    return (
        <Layout breadcrumbs={ [ { text: 'Tribunal' }, { text: 'Acuerdo' }, { text: 'Elaborar acuerdo' } ] } backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {
                loading
                ?
                    <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                        <CircularProgressIndicator />
                    </Box>
                :
                    ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                    ?
                        procesoNoEncontrado
                        ?
                            <BoxProcesoNoEncontrado />
                        :
                            procesoCancelado
                            ?
                                <BoxProcesoCancelado />
                            :
                                <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ acuerdo.idEstatus === 3 } />
                    :
                        <>

                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                <Tabs value={ value } onChange={ handleChange }>

                                    <Tab label="Acuerdo" {...TabProps(0)} />
                                    <Tab label="Notificación" {...TabProps(1)} />

                                    <Tab
                                        label="Información del promoción"
                                        sx={{ display: tabValidation.idPromocion !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(2)}
                                    />

                                    <Tab
                                        label="Información del amparo"
                                        sx={{ display: tabValidation.idAmparo !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(3)}
                                    />

                                <Tab
                                        label={ tabValidation.idDemandaInicial ? " Información de la demanda" : "Información del expediente" }
                                        sx={{ display: ( tabValidation.idExpediente !== 0 || tabValidation.idDemandaInicial !== 0 ) ? 'flex' : 'none' }}
                                        {...TabProps(4)}
                                    />

                                    <Tab
                                        label="Información del exhorto"
                                        sx={{ display: tabValidation.idExhortoRecibido !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(5)}
                                    />

                                    <Tab
                                        label="Información del irregular"
                                        sx={{ display: tabValidation.idIrregular !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(6)}
                                    />

                                </Tabs>

                            </Box>

                            <TabPanel value={ value } index={ 0 }>

                                <Box p={ 4 } component={ Paper }>

                                    <BoxHeaderInformacion numeroSeguimiento={`GAC-${ acuerdo.idAcuerdo }`} fecha={ acuerdo.fecha ?? new Date() } juez={ acuerdo.juez } />

                                    {
                                        acumulacion
                                        &&
                                            <Grid container mt={ 2 }>

                                                <Grid size={{ md: 12, xs: 12 }}>

                                                    <Alert severity="info" color="warning">
                                                        <strong>Se encontraron coincidencias de este expediente para acumular</strong>
                                                    </Alert>

                                                </Grid>

                                            </Grid>
                                    }

                                    <Grid container spacing={ 3 } mt={ 3 }>

                                        <Grid size={{ md: 6, xs: 12 }}>

                                            {
                                                ( acuerdo.oficioso || edit )
                                                ?
                                                    <FormControl fullWidth disabled={ tabValidation.idPromocion !== 0 && tabValidation.idIrregular !== 0 }>

                                                        <InputLabel>Tipo de acuerdo</InputLabel>

                                                        <Select
                                                            label="Tipo de acuerdo"
                                                            value={ tipoAcuerdo }
                                                            onChange={ (e) => handleChangeTipoAcuerdo( e.target.value ) }
                                                        >

                                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>

                                                            {/* Reglas para la unidad de admisibilidad */}

                                                            {
                                                                (
                                                                    idUnidad === 1 &&
                                                                    (
                                                                        tabValidation.idDemandaInicial !== 0 ||
                                                                        ( tabValidation.idPromocion !== 0 && tabValidation.idExhortoRecibido === 0 && acuerdo.expediente.idEtapa === 2 )
                                                                    )
                                                                )
                                                                &&
                                                                    tipoAcuerdoArray
                                                                    .filter( ({ idTipoAcuerdo }) =>
                                                                        idTipoAcuerdo === 1 ||
                                                                        idTipoAcuerdo === 2 ||
                                                                        idTipoAcuerdo === 3
                                                                    )
                                                                    .map( ({ idTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {
                                                                ( idUnidad === 1 && tabValidation.idExhortoRecibido !== 0 )
                                                                &&
                                                                    tipoAcuerdoArray
                                                                    .filter( ({ idTipoAcuerdo }) =>
                                                                        idTipoAcuerdo === 15
                                                                    )
                                                                    .map( ({ idTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {/* Reglas para la unidad de admisibilidad en el tipo de trámite exhorto recibido */}

                                                            {
                                                                (
                                                                    idUnidad === 1 &&
                                                                    acuerdo.exhortoRecibido.idEstatus === 5 &&
                                                                    tabValidation.idExhortoRecibido !== 0 &&
                                                                    tabValidation.idPromocion === 0
                                                                )
                                                                &&
                                                                    tipoAcuerdoArray
                                                                    .filter( ({ idTipoAcuerdo }) => idTipoAcuerdo === 3 )
                                                                    .map( ({ idTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {/* Reglas para la unidad de trámite de menor y mayor cuantía */}

                                                            {
                                                                (
                                                                   ( idUnidad === 2 || idUnidad === 5 ) &&
                                                                   tabValidation.idExpediente !== 0 &&
                                                                   acuerdo.oficioso &&
                                                                   acuerdo.expediente.idEstatus === 5
                                                                )
                                                                &&
                                                                    tipoAcuerdoArray
                                                                    .filter( ({ idTipoAcuerdo }) => idTipoAcuerdo === 3 )
                                                                    .map( ({ idTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {
                                                                (
                                                                    ( idUnidad === 2 || idUnidad === 5 ) &&
                                                                    acuerdo.idPromocion !== 0 &&
                                                                    acuerdo.idExpediente !== 0 &&
                                                                    acuerdo.expediente.idEtapa === 6
                                                                )
                                                                &&
                                                                    tipoAcuerdoArray
                                                                    .filter( ({ idTipoAcuerdo }) =>
                                                                        idTipoAcuerdo === 5 ||
                                                                        idTipoAcuerdo === 6 ||
                                                                        idTipoAcuerdo === 7
                                                                    )
                                                                    .map( ({ idTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {/* Reglas para la unidad de amparos, ejecución y conciliación */}

                                                            {
                                                                ( idUnidad === 3 && tabValidation.idAmparo !== 0 )
                                                                &&
                                                                    tipoAcuerdoArray
                                                                    .filter( ({ idTipoAcuerdo }) =>
                                                                        idTipoAcuerdo === 12
                                                                    )
                                                                    .map( ({ idTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {
                                                                (
                                                                    idUnidad === 3 &&
                                                                    tabValidation.idPromocion !== 0 &&
                                                                    tabValidation.idExpediente !== 0 &&
                                                                    tabValidation.idAmparo === 0
                                                                )
                                                                &&
                                                                    tipoAcuerdoArray
                                                                    .filter( ({ idTipoAcuerdo }) =>
                                                                        idTipoAcuerdo === 13
                                                                    )
                                                                    .map( ({ idTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {/* Reglas para el tipo de acuerdo citación de sentencia */}

                                                            {
                                                                (
                                                                    (
                                                                        (
                                                                            ( idUnidad === 2 || idUnidad === 5 ) &&
                                                                            acuerdo.idExpediente !== 0 &&
                                                                            [ 12, 17, 42 ].includes( acuerdo.expediente.idSubEtapa )
                                                                        ) ||
                                                                        ( idUnidad === 3 && ( acuerdo.expediente.incidente || acuerdo.expediente.medioImpugnacion ) )
                                                                    ) &&
                                                                    acuerdo.oficioso
                                                                )
                                                                &&
                                                                    tipoAcuerdoArray
                                                                    .filter( ({ idTipoAcuerdo }) => idTipoAcuerdo === 10 )
                                                                    .map( ({ idTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {/* Reglas para el tipo de acuerdo citación de sentencia desde promoción (incidente o medio de impugnación) */}

                                                            {
                                                                (
                                                                    idUnidad === 3 &&
                                                                    tabValidation.idPromocion !== 0 &&
                                                                    tabValidation.idExpediente !== 0 &&
                                                                    tabValidation.idAmparo === 0 &&
                                                                    tabValidation.idExhortoRecibido === 0 &&
                                                                    tabValidation.idIrregular === 0 &&
                                                                    ( acuerdo.expediente.incidente || acuerdo.expediente.medioImpugnacion )
                                                                )
                                                                &&
                                                                    tipoAcuerdoArray
                                                                    .filter( ({ idTipoAcuerdo }) => idTipoAcuerdo === 10 )
                                                                    .map( ({ idTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {/* Reglas para el tipo de acuerdo prórroga de plazo de citación de sentencia */}

                                                            {
                                                                (
                                                                    ( idUnidad === 2 || idUnidad === 5 ) &&
                                                                    acuerdo.idExpediente !== 0 &&
                                                                    acuerdo.expediente.idEtapa === 12 &&
                                                                    acuerdo.oficioso
                                                                )
                                                                &&
                                                                    tipoAcuerdoArray
                                                                    .filter( ({ idTipoAcuerdo }) => idTipoAcuerdo === 11 )
                                                                    .map( ({ idTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {/* Reglas para el tipo de acuerdo general - visto */}

                                                            {
                                                                tipoAcuerdoArray
                                                                .filter( ({ idTipoAcuerdo }) => idTipoAcuerdo === 17 )
                                                                .map( ({ idTipoAcuerdo, descripcion }) => (
                                                                    <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                ))
                                                            }

                                                            {/* Reglas para el tipo de acuerdo autorización de expediente virtual */}

                                                            {
                                                                (
                                                                    ( idUnidad === 2 || idUnidad === 5 ) &&
                                                                    tabValidation.idExpediente !== 0 &&
                                                                    tabValidation.idAmparo === 0 &&
                                                                    acuerdo.oficioso
                                                                )
                                                                &&
                                                                    tipoAcuerdoArray
                                                                    .filter( ({ idTipoAcuerdo }) => idTipoAcuerdo === 16 )
                                                                    .map( ({ idTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {/* Reglas para el tipo de acuerdo archivo provisional */}

                                                            {
                                                                (
                                                                    (
                                                                        ( idUnidad === 2 || idUnidad === 5 ) &&
                                                                        tabValidation.idExpediente !== 0 &&
                                                                        acuerdo.expediente.idEtapa === 3 &&
                                                                        acuerdo.oficioso
                                                                    ) ||
                                                                    (
                                                                        tabValidation.idExhortoRecibido !== 0 &&
                                                                        acuerdo.exhortoRecibido.idSubEtapa === 36 &&
                                                                        acuerdo.oficioso
                                                                    )
                                                                )
                                                                &&
                                                                    tipoAcuerdoArray
                                                                    .filter( ({ idTipoAcuerdo }) => idTipoAcuerdo === 18 )
                                                                    .map( ({ idTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {/* Reglas para el tipo de acuerdo de convenio */}

                                                            {
                                                                (
                                                                    ( idUnidad === 1 || idUnidad === 2 || idUnidad === 4 || idUnidad === 5 ) &&
                                                                    acuerdo.idExpediente !== 0
                                                                )
                                                                &&
                                                                    tipoAcuerdoArray
                                                                    .filter( ({ idTipoAcuerdo }) => idTipoAcuerdo === 4 )
                                                                    .map( ({ idTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {/* Reglas para el tipo de acuerdo de Remisión a la alzada */}

                                                            {
                                                                (
                                                                    acuerdo.idExpediente !== 0 &&
                                                                    acuerdo.expediente.medioImpugnacion
                                                                )
                                                                &&
                                                                    tipoAcuerdoArray
                                                                    .filter( ({ idTipoAcuerdo }) => idTipoAcuerdo === 21 )
                                                                    .map( ({ idTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {/* Reglas para el acuerdo de irregular */}

                                                            {
                                                                (
                                                                    acuerdo.idIrregular !== 0 &&
                                                                    acuerdo.oficioso
                                                                )
                                                                &&
                                                                    tipoAcuerdoArray
                                                                    .filter( ({ idTipoAcuerdo }) => idTipoAcuerdo === 14 )
                                                                    .map( ({ idTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                        </Select>

                                                    </FormControl>
                                                :
                                                    <InfoField
                                                        chip
                                                        label="Tipo de acuerdo"
                                                        value={`${acuerdo.tipoAcuerdo}${acuerdo.subTipoAcuerdo ? ` (${acuerdo.subTipoAcuerdo})` : ""}`}
                                                    />
                                            }

                                        </Grid>

                                        {
                                            ( acuerdo.oficioso || edit )
                                            &&
                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <FormControl fullWidth disabled={ tabValidation.idPromocion !== 0 && tabValidation.idIrregular !== 0 }>

                                                        <InputLabel>Subtipo de acuerdo</InputLabel>

                                                        <Select
                                                            label="Subtipo de acuerdo"
                                                            value={ subTipoAcuerdo }
                                                            onChange={ (e) => setSubTipoAcuerdo( e.target.value ) }
                                                            disabled={ tipoAcuerdo === 0 || subTipoAcuerdoArray.length === 0 }
                                                        >

                                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>

                                                            {/* Reglas para el tipo de acuerdo concluido y unidad de admisibilidad */}

                                                            {
                                                                (
                                                                    idUnidad === 1 &&
                                                                    tipoAcuerdo === 3 &&
                                                                    tabValidation.idDemandaInicial !== 0
                                                                )
                                                                &&
                                                                    subTipoAcuerdoArray
                                                                    .filter( ({ idSubTipoAcuerdo }) =>
                                                                        idSubTipoAcuerdo === 1 ||
                                                                        idSubTipoAcuerdo === 2 ||
                                                                        idSubTipoAcuerdo === 3
                                                                    )
                                                                    .map( ({ idSubTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idSubTipoAcuerdo } value={ idSubTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {/* Reglas para el tipo de acuerdo concluido y unidad de admisibilidad, cuando es un exhorto recibido */}

                                                            {
                                                                (
                                                                    idUnidad === 1 &&
                                                                    tipoAcuerdo === 3 &&
                                                                    tabValidation.idExhortoRecibido !== 0 &&
                                                                    acuerdo.oficioso
                                                                )
                                                                &&
                                                                    subTipoAcuerdoArray
                                                                    .filter( ({ idSubTipoAcuerdo }) => idSubTipoAcuerdo === 1 )
                                                                    .map( ({ idSubTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idSubTipoAcuerdo } value={ idSubTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {/* Reglas para el tipo de acuerdo concluido y unidad de trámite de menor y mayor cuantía */}

                                                            {
                                                                (
                                                                    ( idUnidad === 2 || idUnidad === 5 ) &&
                                                                    tipoAcuerdo === 3 &&
                                                                    tabValidation.idExpediente !== 0
                                                                )
                                                                &&
                                                                    subTipoAcuerdoArray
                                                                    .filter( ({ idSubTipoAcuerdo }) =>
                                                                        idSubTipoAcuerdo === 1 ||
                                                                        idSubTipoAcuerdo === 5 ||
                                                                        idSubTipoAcuerdo === 6
                                                                    )
                                                                    .map( ({ idSubTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idSubTipoAcuerdo } value={ idSubTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {/* Regla para el tipo de acuerdo conclusión por resolución en la unidad de trámite de menor y mayor cuantía */}

                                                            {
                                                                (
                                                                    ( idUnidad === 2 || idUnidad === 5 ) &&
                                                                    tipoAcuerdo === 3 &&
                                                                    acuerdo.oficioso &&
                                                                    tabValidation.idExpediente !== 0 &&
                                                                    ( acuerdo.expediente.idEtapa === 11 || acuerdo.expediente.idSubEtapa === 22 )
                                                                )
                                                                &&
                                                                    subTipoAcuerdoArray
                                                                    .filter( ({ idSubTipoAcuerdo }) => idSubTipoAcuerdo === 7 )
                                                                    .map( ({ idSubTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idSubTipoAcuerdo } value={ idSubTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {/* Reglas para el tipo de acuerdo Exhorto */}

                                                            {
                                                                (
                                                                    tipoAcuerdo === 15 &&
                                                                    tabValidation.idExhortoRecibido !== 0 &&
                                                                    tabValidation.idPromocion === 0
                                                                )
                                                                &&
                                                                    subTipoAcuerdoArray
                                                                    .filter( ({ idSubTipoAcuerdo }) =>
                                                                        idSubTipoAcuerdo === 26
                                                                    )
                                                                    .map( ({ idSubTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idSubTipoAcuerdo } value={ idSubTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {
                                                                (
                                                                    tipoAcuerdo === 15 &&
                                                                    tabValidation.idExhortoRecibido !== 0 &&
                                                                    tabValidation.idPromocion !== 0
                                                                )
                                                                &&
                                                                    subTipoAcuerdoArray
                                                                    .filter( ({ idSubTipoAcuerdo }) =>
                                                                        idSubTipoAcuerdo === 28
                                                                    )
                                                                    .map( ({ idSubTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idSubTipoAcuerdo } value={ idSubTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {
                                                                (
                                                                    tipoAcuerdo === 15 &&
                                                                    tabValidation.idExhortoRecibido !== 0
                                                                )
                                                                &&
                                                                    subTipoAcuerdoArray
                                                                    .filter( ({ idSubTipoAcuerdo }) =>
                                                                        idSubTipoAcuerdo === 27
                                                                    )
                                                                    .map( ({ idSubTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idSubTipoAcuerdo } value={ idSubTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {/* Reglas para la unidad de amparos, ejecución y conciliación */}

                                                            {
                                                                (
                                                                    idUnidad === 3 &&
                                                                    tipoAcuerdo === 13
                                                                )
                                                                &&
                                                                    subTipoAcuerdoArray
                                                                    .filter( ({ idSubTipoAcuerdo }) => idSubTipoAcuerdo !== 23 )
                                                                    .map( ({ idSubTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idSubTipoAcuerdo } value={ idSubTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {
                                                                (
                                                                    idUnidad === 3 &&
                                                                    tipoAcuerdo === 12 &&
                                                                    tabValidation.idPromocion === 0 &&
                                                                    acuerdo.amparo.idTipoAmparo === 1
                                                                )
                                                                &&
                                                                    subTipoAcuerdoArray
                                                                    .filter( ({ idSubTipoAcuerdo }) =>
                                                                        idSubTipoAcuerdo === 13
                                                                    )
                                                                    .map( ({ idSubTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idSubTipoAcuerdo } value={ idSubTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {
                                                                (
                                                                    idUnidad === 3 &&
                                                                    tipoAcuerdo === 12 &&
                                                                    tabValidation.idPromocion === 0 &&
                                                                    acuerdo.amparo.idTipoAmparo === 2
                                                                )
                                                                &&
                                                                    subTipoAcuerdoArray
                                                                    .filter( ({ idSubTipoAcuerdo }) =>
                                                                        idSubTipoAcuerdo === 14
                                                                    )
                                                                    .map( ({ idSubTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idSubTipoAcuerdo } value={ idSubTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {
                                                                (
                                                                    idUnidad === 3 &&
                                                                    tipoAcuerdo === 12 &&
                                                                    tabValidation.idPromocion !== 0
                                                                )
                                                                &&
                                                                    subTipoAcuerdoArray
                                                                    .filter( ({ idSubTipoAcuerdo }) =>
                                                                        idSubTipoAcuerdo === 15 ||
                                                                        idSubTipoAcuerdo === 16
                                                                    )
                                                                    .map( ({ idSubTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idSubTipoAcuerdo } value={ idSubTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {/* Reglas para el tipo de acuerdo de convenio */}

                                                            {
                                                                (
                                                                    tipoAcuerdo === 4
                                                                )
                                                                &&
                                                                    subTipoAcuerdoArray
                                                                    .map( ({ idSubTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idSubTipoAcuerdo } value={ idSubTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                            {/* Reglas para el acuerdo de irregular */}

                                                            {
                                                                (
                                                                    tipoAcuerdo === 14 &&
                                                                    acuerdo.idIrregular !== 0 &&
                                                                    acuerdo.oficioso
                                                                )
                                                                &&
                                                                    subTipoAcuerdoArray
                                                                    .map( ({ idSubTipoAcuerdo, descripcion }) => (
                                                                        <MenuItem key={ idSubTipoAcuerdo } value={ idSubTipoAcuerdo }>{ descripcion }</MenuItem>
                                                                    ))
                                                            }

                                                        </Select>

                                                    </FormControl>

                                                </Grid>
                                        }

                                        {/* Esta información es cuando se marca que el acuerdo saldra reservado en la lista de acuerdos  */}

                                        {
                                            tabValidation.idDemandaInicial !== 0
                                            ?
                                                edit
                                                ?
                                                    <Grid size={{ md: 12, xs: 12 }}>

                                                        <FormControl fullWidth>

                                                            <Grid container spacing={ 3 }>

                                                                <Grid size={{ md: 6, xs: 12 }} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} >
                                                                    <FormLabel sx={{ color: 'black' }} >El acuerdo está reservado para:</FormLabel>
                                                                </Grid>

                                                                <Grid size={{ md: 6, xs: 12 }} >
                                                                    <RadioGroup row >
                                                                        <Grid container >
                                                                            <Grid size={{ md: 6, xs: 6 }}>
                                                                                <FormControlLabel
                                                                                    value="Actor(es)"
                                                                                    label="Actor(es)"
                                                                                    control={
                                                                                        <Checkbox
                                                                                            checked={ tipoReservadoActor }
                                                                                            onChange={ (e) => setTipoReservadoActor( e.target.checked ) }
                                                                                        />
                                                                                    }
                                                                                />
                                                                            </Grid>
                                                                            <Grid size={{ md: 6, xs: 6 }}>
                                                                                <FormControlLabel
                                                                                    value="Demandado(s)"
                                                                                    label="Demandado(s)"
                                                                                    control={
                                                                                        <Checkbox
                                                                                            checked={ tipoReservadoDemandado }
                                                                                            onChange={ (e) => setTipoReservadoDemandado( e.target.checked ) }
                                                                                        />
                                                                                    }
                                                                                />
                                                                            </Grid>
                                                                        </Grid>
                                                                    </RadioGroup>
                                                                </Grid>

                                                            </Grid>

                                                        </FormControl>

                                                    </Grid>
                                                :
                                                    ( tipoReservadoActor || tipoReservadoDemandado )
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>

                                                            <InfoField
                                                                chip
                                                                label="El acuerdo está reservado para"
                                                                value={
                                                                    ( tipoReservadoActor && tipoReservadoDemandado )
                                                                    ? 'Ambos - Actor(es) y Demandado(s)'
                                                                    : tipoReservadoActor
                                                                    ? 'Actor(es)'
                                                                    : tipoReservadoDemandado
                                                                    ? 'Demandado(s)'
                                                                    : ''
                                                                }
                                                            />

                                                        </Grid>
                                            : null
                                        }

                                        {/* Modulo para autorizar expediente virtual  */}

                                        {
                                            (
                                                tipoAcuerdo !== 0 &&
                                                ( idUnidad === 1 || idUnidad === 2 || idUnidad === 3 || idUnidad === 4 || idUnidad === 5 ) &&
                                                (
                                                    tabValidation.idDemandaInicial !== 0 ||
                                                    (
                                                        tabValidation.idExpediente !== 0 &&
                                                        tabValidation.idAmparo === 0 &&
                                                        ( tabValidation.idPromocion !== 0 || acuerdo.oficioso )
                                                    )
                                                )
                                            )
                                            ?
                                                edit
                                                ?
                                                    <Grid size={{ md: 12, xs: 12 }}>

                                                        <FormControl fullWidth>

                                                            <Grid container spacing={ 3 }>

                                                                <Grid size={{ md: 6, xs: 12 }} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} >
                                                                    <FormLabel sx={{ color: 'black' }} >¿Desea autorizar el expediente virtual?</FormLabel>
                                                                </Grid>

                                                                <Grid size={{ md: 6, xs: 12 }} >

                                                                    <RadioGroup row >

                                                                        <Grid container >
                                                                            <Grid size={{ md: 6, xs: 6 }}>
                                                                                <FormControlLabel value="Si" control={ <Radio checked={ autorizarExpedienteVirtual } onChange={ () => { setAutorizarExpedienteVirtual( true ); setUsuarioPL( defaultUsuarioPoderEnLinea ); } } /> } label="Si" />
                                                                            </Grid>
                                                                            <Grid size={{ md: 6, xs: 6 }}>
                                                                                <FormControlLabel value="No" control={ <Radio checked={ !autorizarExpedienteVirtual } onChange={ () => { setAutorizarExpedienteVirtual( false ); setUsuarioPL( defaultUsuarioPoderEnLinea ); } } /> } label="No" />
                                                                            </Grid>
                                                                        </Grid>

                                                                    </RadioGroup>

                                                                </Grid>

                                                            </Grid>

                                                        </FormControl>

                                                    </Grid>
                                                :
                                                    <Grid size={{ md: 6, xs: 12 }}>

                                                        <InfoField
                                                            chip
                                                            label="Se autorizar el expediente virtual"
                                                            value={ autorizarExpedienteVirtual ? 'Si' : 'No'}
                                                        />

                                                    </Grid>
                                            : null
                                        }

                                        {
                                            ( autorizarExpedienteVirtual || tipoAcuerdo === 16 )
                                            &&
                                                <Grid size={{ md: 12, xs: 12 }}>

                                                    <Card>

                                                        <CardHeader
                                                            sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                                                            subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Información de la cuenta </Typography> }
                                                        />

                                                        <Divider />

                                                        <CardContent>

                                                            <Grid container spacing={ 3 }>

                                                                {
                                                                    ( edit || acuerdo.oficioso )
                                                                    &&
                                                                        <>

                                                                            <Grid size={{ md: 10, xs: 12 }}>

                                                                                <TextField
                                                                                    label='Buscar solicitante (correo electrónico o teléfono celular )'
                                                                                    variant="outlined"
                                                                                    fullWidth
                                                                                    value={ cuentaPL }
                                                                                    onChange={ (e) => setCuentaPL( e.target.value ) }
                                                                                    autoComplete="off"
                                                                                />

                                                                            </Grid>

                                                                            <Grid size={{ md: 2, xs: 12 }}>

                                                                                <Button
                                                                                    variant='contained'
                                                                                    color={ 'primary' }
                                                                                    fullWidth
                                                                                    startIcon={ <SearchIcon /> }
                                                                                    disabled={ cuentaPL === '' }
                                                                                    loading={ loadingCuentaPL }
                                                                                    onClick={ handleBuscarUsuarioPoderEnLinea }
                                                                                >
                                                                                    Buscar
                                                                                </Button>

                                                                            </Grid>

                                                                        </>
                                                                }

                                                                {
                                                                    usuarioPL.id
                                                                    &&
                                                                        <Grid size={ 12 }>

                                                                            <Grid container spacing={ 3 }>

                                                                                <Grid size={ 4 }>

                                                                                    <InfoField
                                                                                        label="Solicitante"
                                                                                        value={ usuarioPL.solicitante }
                                                                                    />

                                                                                </Grid>

                                                                                <Grid size={ 4 }>

                                                                                    <InfoField
                                                                                        label="Correo electrónico"
                                                                                        value={ usuarioPL.correoElectronico }
                                                                                    />

                                                                                </Grid>

                                                                                <Grid size={ 4 }>

                                                                                    <InfoField
                                                                                        label="Teléfono celular"
                                                                                        value={ usuarioPL.telefonoCelular }
                                                                                    />

                                                                                </Grid>

                                                                            </Grid>

                                                                        </Grid>
                                                                }

                                                            </Grid>

                                                        </CardContent>

                                                    </Card>

                                                </Grid>
                                        }

                                        {/* Esta información es la acumulación de asuntos  */}

                                        {
                                            subTipoAcuerdo === 4
                                            &&
                                                <Grid size={{ md: 12, xs: 12 }}>

                                                    <Card>

                                                        <CardHeader
                                                            sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                                                            subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Acumulación </Typography> }
                                                        />

                                                        <Divider />

                                                        <CardContent>

                                                            <Grid container spacing={ 3 }>

                                                                <Grid size={{ md: 12, xs: 12 }}>

                                                                    <FormControl fullWidth>
                                                                        <InputLabel>Seleccione el expediente principal</InputLabel>

                                                                        <Select
                                                                            label="Seleccione el expediente principal"
                                                                            value={ 0 }
                                                                            onChange={ () => {} }
                                                                        >
                                                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>

                                                                            <MenuItem key={ 1 } value={ 1 }>
                                                                                <strong>Exp. { '1/2026' }</strong>&nbsp;- Secretario(a) de Acuerdo y Trámite:&nbsp;<strong>{ 'Eduardo Antonio Velazquez Lozano' }</strong>&nbsp; - Fecha:&nbsp;<strong>({ '21-01-2026 06:57 p.m' })</strong>
                                                                            </MenuItem>

                                                                        </Select>

                                                                    </FormControl>

                                                                </Grid>

                                                            </Grid>

                                                        </CardContent>

                                                    </Card>

                                                </Grid>
                                        }

                                        {/* Esta información es cuando se selecciona un acuerdo que permita enviar el expediente a archivo provisional  */}

                                        {
                                            ( tipoAcuerdo === 3 ||  subTipoAcuerdo === 10 )
                                            ?
                                                acuerdo.oficioso
                                                ?
                                                    <Grid size={{ md: 12, xs: 12 }}>

                                                        <FormControl fullWidth>

                                                            <Grid container spacing={ 3 }>

                                                                <Grid size={{ md: 6, xs: 12 }} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} >
                                                                    <FormLabel sx={{ color: 'black' }} >¿Desea enviar el expediente al archivo provisional?</FormLabel>
                                                                </Grid>

                                                                <Grid size={{ md: 6, xs: 12 }} >
                                                                    <RadioGroup row >
                                                                        <Grid container >
                                                                            <Grid size={{ md: 6, xs: 6 }}>
                                                                                <FormControlLabel value="Si" control={ <Radio checked={ archivoProvisional } onChange={ () => setArchivoProvisional( true ) } /> } label="Si" />
                                                                            </Grid>
                                                                            <Grid size={{ md: 6, xs: 6 }}>
                                                                                <FormControlLabel value="No" control={ <Radio checked={ !archivoProvisional } onChange={ () => setArchivoProvisional( false ) } /> } label="No" />
                                                                            </Grid>
                                                                        </Grid>
                                                                    </RadioGroup>
                                                                </Grid>

                                                            </Grid>

                                                        </FormControl>

                                                    </Grid>
                                                :
                                                    <Grid size={{ md: 6, xs: 12 }}>

                                                        <InfoField
                                                            chip
                                                            label="Se enviará el expediente al archivo provisional"
                                                            value={ archivoProvisional ? 'Si' : 'No' }
                                                        />

                                                    </Grid>
                                            : null

                                        }

                                        {/* Esta información es cuando se solicita prorroga de plazo  */}

                                        {
                                            tipoAcuerdo === 11
                                            &&
                                                <Grid size={{ md: 12, xs: 12 }}>

                                                    <Card>

                                                        <CardHeader
                                                            sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                                                            subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Información de citación de sentencia </Typography> }
                                                        />

                                                        <Divider />

                                                        <CardContent>

                                                            <Grid container spacing={ 3 } mt={ 1 }>

                                                                <Grid size={{ md: 12, xs: 12 }}>

                                                                    <FormControl fullWidth>

                                                                        <InputLabel>Citación de sentencia</InputLabel>

                                                                        <Select
                                                                            label="Citación de sentencia"
                                                                            value={ citacionSentencia }
                                                                            onChange={ e => setCitacionSentencia( e.target.value ) }
                                                                            renderValue={ selected => {

                                                                                if (  selected === 0 ) return 'Selecciona una opción';

                                                                                const citacion = citacionSentenciaArray.find( c => c.idCitacionSentencia === selected );

                                                                                return (
                                                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0 }}>

                                                                                        <Box sx={{ pr: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                            <Typography variant='caption' color='text.secondary'>Fecha</Typography>
                                                                                            <Typography variant='body2' fontWeight='bold'>
                                                                                                { citacion?.fecha ? moment( citacion.fecha ).format('DD-MM-YYYY hh:mm a') : '' }
                                                                                            </Typography>
                                                                                        </Box>

                                                                                        <Box sx={{ px: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                            <Typography variant='caption' color='text.secondary'>Tipo de sentencia</Typography>
                                                                                            <Typography variant='body2' fontWeight='bold'>{ citacion?.tipoSentencia }</Typography>
                                                                                        </Box>

                                                                                        <Box sx={{ pl: 1.5, flex: 1 }}>
                                                                                            <Typography variant='caption' color='text.secondary'>Citada en</Typography>
                                                                                            <Typography variant='body2' fontWeight='bold'>{ citacion?.tipoAudiencia || citacion?.tipoAcuerdo }</Typography>
                                                                                        </Box>

                                                                                    </Box>
                                                                                );
                                                                            }}
                                                                        >
                                                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>

                                                                            {
                                                                                citacionSentenciaArray.map( ({ idCitacionSentencia, fecha, tipoSentencia, tipoAudiencia, tipoAcuerdo }) => (

                                                                                    <MenuItem key={ idCitacionSentencia } value={ idCitacionSentencia }>

                                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, width: '100%' }}>

                                                                                            <Box sx={{ pr: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                <Typography variant='caption' color='text.secondary'>Fecha</Typography>
                                                                                                <Typography variant='body2' fontWeight='bold'>
                                                                                                    { fecha ? moment( fecha ).format('DD-MM-YYYY hh:mm a') : '' }
                                                                                                </Typography>
                                                                                            </Box>

                                                                                            <Box sx={{ px: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                <Typography variant='caption' color='text.secondary'>Tipo de sentencia</Typography>
                                                                                                <Typography variant='body2' fontWeight='bold'>{ tipoSentencia }</Typography>
                                                                                            </Box>

                                                                                            <Box sx={{ pl: 1.5, flex: 1 }}>
                                                                                                <Typography variant='caption' color='text.secondary'>Citada en</Typography>
                                                                                                <Typography variant='body2' fontWeight='bold'>{ tipoAudiencia || tipoAcuerdo }</Typography>
                                                                                            </Box>

                                                                                        </Box>

                                                                                    </MenuItem>

                                                                                ))
                                                                            }

                                                                        </Select>

                                                                    </FormControl>

                                                                </Grid>

                                                            </Grid>

                                                        </CardContent>

                                                    </Card>

                                                </Grid>
                                        }

                                        {/* Esta información es cuando se marca que la promoción sera irregular y esto es para un acuerdo general */}

                                        {
                                            ( tipoAcuerdo === 17 && tabValidation.idPromocion !== 0 && tabValidation.idExpediente !== 0 )
                                            &&
                                                <Grid size={{ md: 12, xs: 12 }}>

                                                    <FormControl fullWidth disabled={ tabValidation.idIrregular !== 0 }>

                                                        <Grid container spacing={ 3 }>

                                                            {
                                                                edit
                                                                ?
                                                                    <>

                                                                        <Grid size={{ md: 6, xs: 12 }} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} >
                                                                            <FormLabel sx={{ color: 'black' }} >¿Es una promoción irregular?</FormLabel>
                                                                        </Grid>

                                                                        <Grid size={{ md: promocionIrregular ? 2 : 6, xs: 12 }} >

                                                                            <RadioGroup row >

                                                                                <Grid container >

                                                                                    <Grid size={{ md: 6, xs: 6 }}>
                                                                                        <FormControlLabel value="Si" control={ <Radio checked={ promocionIrregular } onChange={ () => setPromocionIrregular( true ) } /> } label="Si" />
                                                                                    </Grid>

                                                                                    <Grid size={{ md: 6, xs: 6 }}>
                                                                                        <FormControlLabel value="No" control={ <Radio checked={ !promocionIrregular } onChange={ () => setPromocionIrregular( false ) } /> } label="No" />
                                                                                    </Grid>

                                                                                </Grid>

                                                                            </RadioGroup>

                                                                        </Grid>

                                                                    </>
                                                                :
                                                                    <Grid size={{ md: 6, xs: 12 }} >

                                                                        <InfoField
                                                                            chip
                                                                            label="¿Es una promoción irregular?"
                                                                            value={ promocionIrregular ? 'Si' : 'No'}
                                                                        />

                                                                    </Grid>
                                                            }

                                                            {
                                                                promocionIrregular
                                                                &&
                                                                    <Grid size={{ md: promocionIrregular ? 4 : 6, xs: 12 }}>

                                                                        <Button variant='contained' onClick={ () => setOpenPartesIrregular( true ) }>
                                                                            { edit ? 'Agregar partes' : 'Visualizar partes' }
                                                                        </Button>

                                                                    </Grid>
                                                            }

                                                        </Grid>

                                                    </FormControl>

                                                </Grid>
                                        }

                                        {/* Esta información es cuando se marca desde la promoción si se citara para sentencia dependiendo del tipo de acuerdo */}

                                        {
                                            (
                                                ( ( tabValidation.idPromocion !== 0 || acuerdo.oficioso ) && tabValidation.idExpediente !== 0 && tipoAcuerdo === 17 && acuerdo.expediente.idEtapa === 10 && ( idUnidad === 2 || idUnidad === 5 ) ) ||
                                                ( ( tabValidation.idPromocion !== 0 || acuerdo.oficioso ) && tabValidation.idExpediente !== 0 && tipoAcuerdo === 17 && ( idUnidad === 3 ) )
                                            )
                                            ?
                                                ( edit || acuerdo.oficioso )
                                                ?
                                                    <Grid size={{ md: 12, xs: 12 }}>

                                                        <FormControl fullWidth disabled={ solicitarFechaAudiencia }>

                                                            <Grid container spacing={ 3 }>

                                                                <Grid size={{ md: 6, xs: 12 }} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} >
                                                                    <FormLabel sx={{ color: 'black' }} >¿La promoción es para citación de sentencia?</FormLabel>
                                                                </Grid>

                                                                <Grid size={{ md: 6, xs: 12 }}>

                                                                    <RadioGroup row >
                                                                        <Grid container >
                                                                            <Grid size={{ md: 6, xs: 6 }}>
                                                                                <FormControlLabel value="Si" control={ <Radio checked={ citaSentencia } onChange={ () => { setCitaSentencia( true ); setSolicitarFechaAudiencia( false ); setTipoAudiencia(0); } } /> } label="Si" />
                                                                            </Grid>
                                                                            <Grid size={{ md: 6, xs: 6 }}>
                                                                                <FormControlLabel value="No" control={ <Radio checked={ !citaSentencia } onChange={ () => setCitaSentencia( false ) } /> } label="No" />
                                                                            </Grid>
                                                                        </Grid>
                                                                    </RadioGroup>

                                                                </Grid>

                                                            </Grid>

                                                        </FormControl>

                                                    </Grid>
                                                :
                                                    <Grid size={{ md: 6, xs: 12 }} >

                                                        <InfoField
                                                            chip
                                                            label="¿La promoción es para citación de sentencia?"
                                                            value={ citaSentencia ? 'Si' : 'No'}
                                                        />

                                                    </Grid>
                                            : null
                                        }

                                        {/*
                                            Esta información es cuando el tipo de acuerdo es citación de sentencia, dependiente de la etapa si la citación de sentencia
                                            se pide por parte de las partes en etapas definidas
                                        */}

                                        {
                                            ( citaSentencia || tipoAcuerdo === 10 )
                                            ?
                                                acuerdo.oficioso
                                                ?
                                                    <Grid size={{ md: 12, xs: 12 }}>

                                                        <FormControl>

                                                            <FormLabel sx={{ color: 'black' }} >Seleccione el tipo de sentencia:</FormLabel>
                                                            <RadioGroup row>

                                                                {
                                                                    ( ( tabValidation.idPromocion !== 0 && tabValidation.idExpediente !== 0 && tipoAcuerdo === 17 && acuerdo.expediente.idEtapa === 10 && ( idUnidad === 2 || idUnidad === 5 ) ) || ( tipoAcuerdo === 10 && acuerdo.oficioso && ( idUnidad === 2 || idUnidad === 5 ) ) )
                                                                    &&
                                                                        <FormControlLabel value="1" control={ <Radio checked={ tipoSentencia === 1 } onChange={ () => setTipoSentencia( 1 ) } />} label="Sentencia Definitiva" />
                                                                }

                                                                {
                                                                    !( tipoAcuerdo === 10 && acuerdo.oficioso && ( idUnidad === 2 || idUnidad === 5 ) )
                                                                    &&
                                                                        <FormControlLabel value="2" control={ <Radio checked={ tipoSentencia === 2 } onChange={ () => setTipoSentencia( 2 ) } />} label="Sentencia Interlocutoria" />
                                                                }

                                                            </RadioGroup>

                                                        </FormControl>

                                                    </Grid>
                                                :
                                                    <Grid size={{ md: 6, xs: 12 }}>

                                                        <InfoField
                                                            chip
                                                            label="Tipo de sentencia"
                                                            value={ acuerdo.tipoSentencia }
                                                        />

                                                    </Grid>
                                            :   null
                                        }

                                        {/* Esta información es para indicar si la promoción se interpondra un incidente */}

                                        {
                                            ( tipoAcuerdo === 17 && tabValidation.idPromocion !== 0 && tabValidation.idExpediente !== 0 && idUnidad === 3 )
                                            ?
                                                edit
                                                ?
                                                    <Grid size={{ md: 12, xs: 12 }}>

                                                        <FormControl fullWidth disabled={ tabValidation.idIrregular !== 0 }>

                                                            <Grid container spacing={ 3 }>

                                                                <Grid size={{ md: 6, xs: 12 }} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} >
                                                                    <FormLabel sx={{ color: 'black' }} >¿La promoción interpone un incidente?</FormLabel>
                                                                </Grid>

                                                                <Grid size={{ md: 6, xs: 12 }}>

                                                                    <RadioGroup row >
                                                                        <Grid container >
                                                                            <Grid size={{ md: 6, xs: 6 }}>
                                                                                <FormControlLabel value="Si" control={ <Radio onChange={ () => {} } /> } label="Si" />
                                                                            </Grid>
                                                                            <Grid size={{ md: 6, xs: 6 }}>
                                                                                <FormControlLabel value="No" control={ <Radio onChange={ () => {} } /> } label="No" />
                                                                            </Grid>
                                                                        </Grid>
                                                                    </RadioGroup>

                                                                </Grid>

                                                            </Grid>

                                                        </FormControl>

                                                    </Grid>
                                                :
                                                    <Grid size={{ md: 6, xs: 12 }}>

                                                        <InfoField
                                                            chip
                                                            label="¿La promoción interpone un incidente?"
                                                            value={ interponeIncidente ? 'Si' : 'No' }
                                                        />

                                                    </Grid>
                                            : null
                                        }

                                        {/* Esta información es para indicar si la promoción se interpondra un recurso */}

                                        {
                                            ( tipoAcuerdo === 17 && tabValidation.idPromocion !== 0 && tabValidation.idExpediente !== 0 && idUnidad === 3 )
                                            ?
                                                edit
                                                ?
                                                    <Grid size={{ md: 12, xs: 12 }}>

                                                        <FormControl fullWidth disabled={ tabValidation.idIrregular !== 0 }>

                                                            <Grid container spacing={ 3 }>

                                                                <Grid size={{ md: 6, xs: 12 }} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} >
                                                                    <FormLabel sx={{ color: 'black' }} >¿La promoción interpone un recurso?</FormLabel>
                                                                </Grid>

                                                                <Grid size={{ md: 6, xs: 12 }} >

                                                                    <RadioGroup row>
                                                                        <Grid container >
                                                                            <Grid size={{ md: 6, xs: 6 }}>
                                                                                <FormControlLabel value="Si" control={ <Radio checked={ interponeRecurso } onChange={ () => setInterponeRecurso( true ) } /> } label="Si" />
                                                                            </Grid>
                                                                            <Grid size={{ md: 6, xs: 6 }}>
                                                                                <FormControlLabel value="No" control={ <Radio checked={ !interponeRecurso } onChange={ () => setInterponeRecurso( false ) } /> } label="No" />
                                                                            </Grid>
                                                                        </Grid>
                                                                    </RadioGroup>

                                                                </Grid>

                                                            </Grid>

                                                        </FormControl>

                                                    </Grid>
                                                :
                                                    <Grid size={{ md: 6, xs: 12 }}>

                                                        <InfoField
                                                            chip
                                                            label="¿La promoción interpone un recurso?"
                                                            value={ interponeRecurso ? 'Si' : 'No' }
                                                        />

                                                    </Grid>
                                            : null
                                        }

                                        {
                                            ( interponeRecurso  && idUnidad === 3  )
                                            &&
                                                <Grid size={{ md: 12, xs: 12 }} >

                                                    <Card>

                                                        <CardHeader
                                                            sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                                                            subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Información del recurso </Typography> }
                                                        />

                                                        <Divider />

                                                        <CardContent>

                                                            <Grid container spacing={ 3 } mt={ 1 }>

                                                                <Grid size={{ md: 6, xs: 12 }}>

                                                                    {
                                                                        edit
                                                                        ?
                                                                            <FormControl fullWidth>

                                                                                <InputLabel>Tipo de recurso</InputLabel>

                                                                                <Select
                                                                                    label="Tipo de recurso"
                                                                                    value={ idTipoRecurso }
                                                                                    onChange={ ( e ) => setMedioImpugnacion({ ...medioImpugnacion, idTipoRecurso: e.target.value }) }
                                                                                >

                                                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                                                    {
                                                                                        tipoRecursoArray.map( ({ idTipoRecurso, descripcion }) => (
                                                                                            <MenuItem key={ idTipoRecurso } value={ idTipoRecurso }>{ descripcion }</MenuItem>
                                                                                        ))
                                                                                    }

                                                                                </Select>

                                                                            </FormControl>
                                                                        :
                                                                            <InfoField
                                                                                chip
                                                                                label="Tipo de recurso"
                                                                                value={ medioImpugnacion.tipoRecurso }
                                                                            />
                                                                    }

                                                                </Grid>

                                                                <Grid size={{ md: 6, xs: 12 }}>

                                                                    {
                                                                        edit
                                                                        ?
                                                                            <FormControl fullWidth>

                                                                                <InputLabel>Autoridad resolutoria</InputLabel>

                                                                                <Select
                                                                                    label="Autoridad resolutoria"
                                                                                    value={ idAutoridadResolutoria }
                                                                                    onChange={ ( e ) => setMedioImpugnacion({ ...medioImpugnacion, idAutoridadResolutoria: e.target.value }) }
                                                                                    disabled={ idTipoRecurso === 0 }
                                                                                >

                                                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                                                    {
                                                                                        idTipoRecurso === 4
                                                                                        ?
                                                                                            autoridadResolutoriaArray
                                                                                            .filter(ar => ar.idAutoridadResolutoria === 3)
                                                                                            .map( ({ idAutoridadResolutoria, descripcion }) => (
                                                                                                <MenuItem key={ idAutoridadResolutoria } value={ idAutoridadResolutoria }>{ descripcion }</MenuItem>
                                                                                            ))
                                                                                        :
                                                                                            autoridadResolutoriaArray
                                                                                            .filter(ar => ar.idAutoridadResolutoria !== 3)
                                                                                            .map( ({ idAutoridadResolutoria, descripcion }) => (
                                                                                                <MenuItem key={ idAutoridadResolutoria } value={ idAutoridadResolutoria }>{ descripcion }</MenuItem>
                                                                                            ))
                                                                                    }

                                                                                </Select>

                                                                            </FormControl>
                                                                        :
                                                                            <InfoField
                                                                                chip
                                                                                label="Autoridad resolutoria"
                                                                                value={ medioImpugnacion.autoridadResolutoria }
                                                                            />
                                                                    }

                                                                </Grid>

                                                                <Grid size={{ md: 6, xs: 12 }}>

                                                                    {
                                                                        edit
                                                                        ?
                                                                            <FormControl fullWidth>

                                                                                <InputLabel>Tipo de resolución</InputLabel>

                                                                                <Select
                                                                                    label="Tipo de resolución"
                                                                                    value={ idTipoResolucion }
                                                                                    onChange={ ( e ) => setMedioImpugnacion({ ...medioImpugnacion, idTipoResolucion: e.target.value }) }
                                                                                    disabled={ idTipoRecurso === 0 }
                                                                                >

                                                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                                                    {
                                                                                        tipoResolucionArray.map( ({ idTipoResolucion, descripcion }) => (
                                                                                            <MenuItem key={ idTipoResolucion } value={ idTipoResolucion }>{ descripcion }</MenuItem>
                                                                                        ))
                                                                                    }

                                                                                </Select>

                                                                            </FormControl>
                                                                        :
                                                                            <InfoField
                                                                                chip
                                                                                label="Tipo de resolución"
                                                                                value={ medioImpugnacion.tipoResolucion }
                                                                            />
                                                                    }

                                                                </Grid>

                                                                <Grid size={{ md: 6, xs: 12 }}>

                                                                    <Grid container spacing={ 3 } alignItems="center">

                                                                        {
                                                                            medioImpugnacionDocumento.nombre
                                                                            &&
                                                                                <Grid size={{ xs: edit ? 8 : 12 }}>

                                                                                    <Box sx={{
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        gap: 1,
                                                                                        px: 1.5,
                                                                                        height: 56,
                                                                                        borderRadius: 1,
                                                                                        border: '1px solid',
                                                                                        borderColor: 'divider',
                                                                                        backgroundColor: 'action.hover'
                                                                                    }}>

                                                                                        <Box sx={{ flex: 1, textAlign: 'center' }}>

                                                                                            <Typography variant='body2' fontWeight='bold'>
                                                                                                Acuerdo de Admisión
                                                                                            </Typography>

                                                                                            <Typography variant='caption' color='text.secondary'>
                                                                                                21-01-2026
                                                                                            </Typography>

                                                                                        </Box>

                                                                                        <Button
                                                                                            variant='contained'
                                                                                            size='small'
                                                                                            sx={{ minWidth: 0, px: 1.5 }}
                                                                                            onClick={ () => {
                                                                                                setDocumento( medioImpugnacionDocumento.url );
                                                                                                setOpenDocumento( true );
                                                                                            }}
                                                                                        >
                                                                                            <VisibilityIcon fontSize='small' />
                                                                                        </Button>

                                                                                    </Box>

                                                                                </Grid>
                                                                        }

                                                                        {
                                                                            edit
                                                                            &&
                                                                                <Grid size={{ xs: medioImpugnacionDocumento.nombre ? 4 : 12 }} sx={{ textAlign: 'center' }}>

                                                                                    <Button
                                                                                        variant='contained'
                                                                                        onClick={ () => setOpenResoluciones( true ) }
                                                                                    >
                                                                                        Agregar resolución
                                                                                    </Button>

                                                                                </Grid>
                                                                        }

                                                                    </Grid>

                                                                </Grid>

                                                                {
                                                                    edit
                                                                    &&
                                                                        <Grid size={{ md: 6, xs: 12 }}>

                                                                            <FormControl fullWidth>

                                                                                <InputLabel>Tipo recurrente</InputLabel>

                                                                                <Select
                                                                                    label="Tipo recurrente"
                                                                                    value={ idTipoRecurrente }
                                                                                    onChange={ ( e ) => setMedioImpugnacion({ ...medioImpugnacion, idTipoRecurrente: e.target.value, idParte: 0, recurrente: '' }) }
                                                                                    disabled={ idTipoRecurso === 0 }
                                                                                >

                                                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                                                    {
                                                                                        tipoRecurrenteArray.map( ({ idTipoRecurrente, descripcion }) => (
                                                                                            <MenuItem key={ idTipoRecurrente } value={ idTipoRecurrente }>{ descripcion }</MenuItem>
                                                                                        ))
                                                                                    }

                                                                                </Select>

                                                                            </FormControl>

                                                                        </Grid>
                                                                }

                                                                {
                                                                    edit
                                                                    ?
                                                                        idTipoRecurrente === 3
                                                                        ?
                                                                            <Grid size={{ md: 6, xs: 12 }}>

                                                                                <TextField
                                                                                    label="Recurrente"
                                                                                    autoComplete="off"
                                                                                    fullWidth
                                                                                    slotProps={{
                                                                                        inputLabel: {
                                                                                            shrink: true
                                                                                        }
                                                                                    }}
                                                                                    value={ recurrente }
                                                                                    onChange={ ( e ) => setMedioImpugnacion({ ...medioImpugnacion, recurrente: e.target.value }) }
                                                                                />

                                                                            </Grid>
                                                                        :
                                                                            <Grid size={{ md: 6, xs: 12 }}>

                                                                                <FormControl fullWidth>

                                                                                    <InputLabel>Reccurente</InputLabel>

                                                                                    <Select
                                                                                        label="Reccurente"
                                                                                        value={ idParte }
                                                                                        onChange={ ( e ) => setMedioImpugnacion({ ...medioImpugnacion, idParte: e.target.value }) }
                                                                                        disabled={ idTipoRecurrente === 0 }
                                                                                    >

                                                                                        <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>

                                                                                        {
                                                                                            idTipoRecurrente === 1
                                                                                            ?
                                                                                                acuerdo.expediente.partes.filter( (e) => e.idTipoParte === 1 )
                                                                                                .map(({ id, persona })=>(
                                                                                                    <MenuItem key={ id } value={ id }>{ persona }</MenuItem>
                                                                                                ))
                                                                                            :
                                                                                                null
                                                                                        }

                                                                                        {
                                                                                            idTipoRecurrente === 2
                                                                                            ?
                                                                                                acuerdo.expediente.partes.filter( (e) => e.idTipoParte === 2 )
                                                                                                .map(({ id, persona })=>(
                                                                                                    <MenuItem key={ id } value={ id }>{ persona }</MenuItem>
                                                                                                ))
                                                                                            :
                                                                                                null
                                                                                        }

                                                                                    </Select>

                                                                                </FormControl>

                                                                            </Grid>
                                                                    :
                                                                        <Grid size={{ md: 6, xs: 12 }}>

                                                                            <InfoField
                                                                                chip
                                                                                label="Recurrente"
                                                                                value={ `${medioImpugnacion.recurrente} (${medioImpugnacion.tipoRecurrente})` }
                                                                            />

                                                                        </Grid>
                                                                }

                                                            </Grid>

                                                        </CardContent>

                                                    </Card>

                                                </Grid>
                                        }

                                        {/* Esta es la información de una promocion donde se resuelve un recurso, validando cuando el expediente esta activado como medio de impugnación */}

                                        {
                                            ( tipoAcuerdo === 17 && tabValidation.idPromocion !== 0 && tabValidation.idExpediente !== 0 && idUnidad === 3 && acuerdo.expediente.medioImpugnacion )
                                            ?
                                                edit
                                                ?
                                                    <Grid size={{ md: 12, xs: 12 }}>

                                                        <FormControl fullWidth disabled={ ( tabValidation.idIrregular !== 0 && promocionIrregular ) }>

                                                            <Grid container spacing={ 3 }>

                                                                <Grid size={{ md: 6, xs: 12 }} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} >
                                                                    <FormLabel sx={{ color: 'black' }} >¿La promoción resuelve un recurso?</FormLabel>
                                                                </Grid>

                                                                <Grid size={{ md: 6, xs: 12 }}>

                                                                    <RadioGroup row >

                                                                        <Grid container >

                                                                            <Grid size={{ md: 6, xs: 6 }}>
                                                                                <FormControlLabel value="Si" control={ <Radio checked={ resuelveRecurso } onChange={ () => handleChangeResulveRecurso( true ) } /> } label="Si" />
                                                                            </Grid>

                                                                                <Grid size={{ md: 6, xs: 6 }}>
                                                                                <FormControlLabel value="No" control={ <Radio checked={ !resuelveRecurso } onChange={ () => handleChangeResulveRecurso( false ) } /> } label="No" />
                                                                            </Grid>

                                                                        </Grid>

                                                                    </RadioGroup>

                                                                </Grid>

                                                            </Grid>

                                                        </FormControl>

                                                    </Grid>
                                                :
                                                    <Grid size={{ md: 6, xs: 12 }}>

                                                        <InfoField
                                                            chip
                                                            label="¿La promoción resuelve un recurso?"
                                                            value={ resuelveRecurso ? 'Si' : 'No' }
                                                        />

                                                    </Grid>

                                            : null
                                        }

                                        {
                                            ( resuelveRecurso && !promocionIrregular )
                                            &&
                                                <Grid size={{ md: 12, xs: 12 }}>

                                                    <Card>

                                                        <CardHeader
                                                            sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                                                            subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Información del recurso </Typography> }
                                                        />

                                                        <Divider />

                                                        <CardContent>

                                                            <Grid container spacing={ 3 }>

                                                                <Grid size={{ md: 12, xs: 12 }}>

                                                                    {
                                                                        edit
                                                                        ?
                                                                            <FormControl fullWidth>

                                                                                <InputLabel>Seleccione el recurso</InputLabel>

                                                                                <Select
                                                                                    label="Seleccione el recurso"
                                                                                    value={ medioImpugnacionSelected }
                                                                                    onChange={ ( e ) => setMedioImpugnacionSelected( e.target.value ) }
                                                                                    renderValue={ ( selected ) => {

                                                                                        if (  selected === 0 ) return 'Selecciona una opción';

                                                                                        const recurso = medioImpugnacionArray.find( ({ idMedioImpugnacion }) => idMedioImpugnacion === selected );

                                                                                        return (
                                                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0 }}>

                                                                                                <Box sx={{ pr: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                    <Typography variant='caption' color='text.secondary'>Tipo</Typography>
                                                                                                    <Typography variant='body2' fontWeight='bold'>{ recurso?.tipoRecurso }</Typography>
                                                                                                </Box>

                                                                                                <Box sx={{ px: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                    <Typography variant='caption' color='text.secondary'>Resolución</Typography>
                                                                                                    <Typography variant='body2' fontWeight='bold'>{ recurso?.tipoResolucion }</Typography>
                                                                                                </Box>

                                                                                                <Box sx={{ px: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                    <Typography variant='caption' color='text.secondary'>Admisión</Typography>
                                                                                                    <Typography variant='body2' fontWeight='bold'>{ recurso?.fechaAdmision ? moment( recurso?.fechaAdmision ).format('DD-MM-YYYY') : '' }</Typography>
                                                                                                </Box>

                                                                                                <Box sx={{ pl: 1.5, flex: 1 }}>
                                                                                                    <Typography variant='caption' color='text.secondary'>Recurrente</Typography>
                                                                                                    <Typography variant='body2' fontWeight='bold'>{ recurso?.recurrente }</Typography>
                                                                                                </Box>

                                                                                            </Box>
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    <MenuItem value={ 0 }>Selecciona una opción</MenuItem>

                                                                                    {
                                                                                        medioImpugnacionArray.map( ({ idMedioImpugnacion, tipoRecurso, tipoResolucion, fechaAdmision, recurrente } ) => (

                                                                                            <MenuItem key={ idMedioImpugnacion } value={ idMedioImpugnacion }>

                                                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, width: '100%' }}>

                                                                                                    <Box sx={{ pr: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                        <Typography variant='caption' color='text.secondary'>Tipo</Typography>
                                                                                                        <Typography variant='body2' fontWeight='bold'>{ tipoRecurso }</Typography>
                                                                                                    </Box>

                                                                                                    <Box sx={{ px: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                        <Typography variant='caption' color='text.secondary'>Resolución</Typography>
                                                                                                        <Typography variant='body2' fontWeight='bold'>{ tipoResolucion }</Typography>
                                                                                                    </Box>

                                                                                                    <Box sx={{ px: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                        <Typography variant='caption' color='text.secondary'>Fecha</Typography>
                                                                                                        <Typography variant='body2' fontWeight='bold'>{ fechaAdmision ? moment( fechaAdmision ).format('DD-MM-YYYY') : '' }</Typography>
                                                                                                    </Box>

                                                                                                    <Box sx={{ pl: 1.5, flex: 1 }}>
                                                                                                        <Typography variant='caption' color='text.secondary'>Recurrente</Typography>
                                                                                                        <Typography variant='body2' fontWeight='bold'>{ recurrente }</Typography>
                                                                                                    </Box>

                                                                                                </Box>

                                                                                            </MenuItem>

                                                                                        ))
                                                                                    }

                                                                                </Select>

                                                                            </FormControl>
                                                                        :
                                                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', gap: 1.5 }}>

                                                                                <Box sx={ chipStyle }>
                                                                                    <Typography variant='caption' color='text.secondary'>Tipo de recurso</Typography>
                                                                                    <Typography variant='body2' fontWeight='bold'>{ tipoRecurso }</Typography>
                                                                                </Box>

                                                                                <Box sx={ chipStyle }>
                                                                                    <Typography variant='caption' color='text.secondary'>Resolución</Typography>
                                                                                    <Typography variant='body2' fontWeight='bold'>{ tipoResolucion }</Typography>
                                                                                </Box>

                                                                                <Box sx={ chipStyle }>
                                                                                    <Typography variant='caption' color='text.secondary'>Fecha de admisión</Typography>
                                                                                    <Typography variant='body2' fontWeight='bold'>
                                                                                        { fechaAdmision ? moment( fechaAdmision ).format('DD-MM-YYYY') : '' }
                                                                                    </Typography>
                                                                                </Box>

                                                                                <Box sx={{ ...chipStyle, flex: 2 }}>
                                                                                    <Typography variant='caption' color='text.secondary'>Recurrente</Typography>
                                                                                    <Typography variant='body2' fontWeight='bold'>{ recurrente }</Typography>
                                                                                </Box>

                                                                            </Box>
                                                                    }

                                                                </Grid>

                                                                <Grid size={{ md: 6, xs: 12 }}>

                                                                    {
                                                                        edit
                                                                        ?
                                                                            <FormControl fullWidth>
                                                                                <InputLabel>Sentido de fallo</InputLabel>

                                                                                <Select
                                                                                    label="Sentido de fallo"
                                                                                    value={ sentidoFallo }
                                                                                    onChange={ ( e ) => setSentidoFallo( e.target.value ) }
                                                                                >

                                                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                                                    {
                                                                                        sentidoFalloArray.map( ({ idSentidoFallo, descripcion }) => (
                                                                                            <MenuItem key={ idSentidoFallo } value={ idSentidoFallo }>{ descripcion }</MenuItem>
                                                                                        ))
                                                                                    }

                                                                                </Select>

                                                                            </FormControl>
                                                                        :
                                                                            <InfoField
                                                                                chip
                                                                                label="Sentido de fallo"
                                                                                value={ sentidoFalloArray.find( ({ idSentidoFallo }) => sentidoFallo )?.descripcion }
                                                                            />
                                                                    }

                                                                </Grid>

                                                                <Grid size={{ md: 6, xs: 12 }}>

                                                                     {
                                                                        edit
                                                                        ?
                                                                            <LocalizationProvider dateAdapter={ AdapterMoment } adapterLocale="es">

                                                                                <DatePicker
                                                                                    label="Fecha devolución"
                                                                                    sx={{ width: '100%' }}
                                                                                    value={ moment( fechaDevolucionAlzada ) }
                                                                                    minDate={ moment( new Date() ) }
                                                                                    onChange={ (e) => setFechaDevolucionAlzada( moment( e ).format( 'YYYY-MM-DD' ) ) }
                                                                                />

                                                                            </LocalizationProvider>
                                                                        :
                                                                            <InfoField
                                                                                chip
                                                                                label="Fecha devolución"
                                                                                value={ fechaDevolucionAlzada ? moment( fechaDevolucionAlzada ).format( 'YYYY-MM-DD' ) : '' }
                                                                            />
                                                                    }

                                                                </Grid>

                                                            </Grid>

                                                        </CardContent>

                                                    </Card>

                                                </Grid>
                                        }

                                        {/* Esta es la información para un acuerdo oficioso para el acuerdo de remisión de alzada  */}

                                        {
                                            tipoAcuerdo === 21
                                            &&
                                                <Grid size={{ md: 12, xs: 12 }}>

                                                    <Card>

                                                        <CardHeader
                                                            sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                                                            subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Información del recurso </Typography> }
                                                        />

                                                        <Divider />

                                                        <CardContent>

                                                            <Grid container spacing={ 3 } mt={ 1 }>

                                                                <Grid size={{ md: 12, xs: 12 }}>

                                                                    <FormControl fullWidth>

                                                                        <InputLabel>Seleccione el recurso</InputLabel>

                                                                        <Select
                                                                            label="Seleccione el recurso"
                                                                            value={ medioImpugnacionSelected }
                                                                            onChange={ ( e ) => setMedioImpugnacionSelected( e.target.value ) }
                                                                            renderValue={ ( selected ) => {

                                                                                if (  selected === 0 ) return 'Selecciona una opción';

                                                                                const recurso = medioImpugnacionArray.find( ({ idMedioImpugnacion }) => idMedioImpugnacion === selected );

                                                                                return (
                                                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0 }}>

                                                                                        <Box sx={{ pr: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                            <Typography variant='caption' color='text.secondary'>Tipo</Typography>
                                                                                            <Typography variant='body2' fontWeight='bold'>{ recurso?.tipoRecurso }</Typography>
                                                                                        </Box>

                                                                                        <Box sx={{ px: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                            <Typography variant='caption' color='text.secondary'>Resolución</Typography>
                                                                                            <Typography variant='body2' fontWeight='bold'>{ recurso?.tipoResolucion }</Typography>
                                                                                        </Box>

                                                                                        <Box sx={{ px: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                            <Typography variant='caption' color='text.secondary'>Admisión</Typography>
                                                                                            <Typography variant='body2' fontWeight='bold'>{ recurso?.fechaAdmision ? moment( recurso?.fechaAdmision ).format('DD-MM-YYYY') : '' }</Typography>
                                                                                        </Box>

                                                                                        <Box sx={{ pl: 1.5, flex: 1 }}>
                                                                                            <Typography variant='caption' color='text.secondary'>Recurrente</Typography>
                                                                                            <Typography variant='body2' fontWeight='bold'>{ recurso?.recurrente }</Typography>
                                                                                        </Box>

                                                                                    </Box>
                                                                                );
                                                                            }}
                                                                        >
                                                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>

                                                                            {
                                                                                medioImpugnacionArray.map( ({ idMedioImpugnacion, tipoRecurso, tipoResolucion, fechaAdmision, recurrente } ) => (

                                                                                    <MenuItem key={ idMedioImpugnacion } value={ idMedioImpugnacion }>

                                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, width: '100%' }}>

                                                                                            <Box sx={{ pr: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                <Typography variant='caption' color='text.secondary'>Tipo</Typography>
                                                                                                <Typography variant='body2' fontWeight='bold'>{ tipoRecurso }</Typography>
                                                                                            </Box>

                                                                                            <Box sx={{ px: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                <Typography variant='caption' color='text.secondary'>Resolución</Typography>
                                                                                                <Typography variant='body2' fontWeight='bold'>{ tipoResolucion }</Typography>
                                                                                            </Box>

                                                                                            <Box sx={{ px: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                <Typography variant='caption' color='text.secondary'>Fecha</Typography>
                                                                                                <Typography variant='body2' fontWeight='bold'>{ fechaAdmision ? moment( fechaAdmision ).format('DD-MM-YYYY') : '' }</Typography>
                                                                                            </Box>

                                                                                            <Box sx={{ pl: 1.5, flex: 1 }}>
                                                                                                <Typography variant='caption' color='text.secondary'>Recurrente</Typography>
                                                                                                <Typography variant='body2' fontWeight='bold'>{ recurrente }</Typography>
                                                                                            </Box>

                                                                                        </Box>

                                                                                    </MenuItem>

                                                                                ))
                                                                            }

                                                                        </Select>

                                                                    </FormControl>

                                                                </Grid>

                                                                <Grid size={{ md: 12, xs: 12 }}>

                                                                    <LocalizationProvider dateAdapter={ AdapterMoment } adapterLocale="es">

                                                                        <DatePicker
                                                                            label="Fecha de remisión a la alzada"
                                                                            sx={{ width: '100%' }}
                                                                            value={ moment( fechaRemisionAlzada ) }
                                                                            minDate={ moment( new Date() ) }
                                                                            onChange={ (e) => { setFechaRemisionAlzada( moment( e ).format( 'YYYY-MM-DD' ) ) } }
                                                                        />

                                                                    </LocalizationProvider>

                                                                </Grid>

                                                            </Grid>

                                                        </CardContent>

                                                    </Card>

                                                </Grid>
                                        }

                                        {/* Esta es la información para un exhorto recibido  */}

                                        {
                                            ( tabValidation.idExhortoRecibido !== 0 && tabValidation.idPromocion === 0 && !acuerdo.oficioso )
                                            &&
                                                <Grid size={{ md: 12, xs: 12 }} >

                                                    <Card>

                                                        <CardHeader
                                                            sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                                                            subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Información del exhorto </Typography> }
                                                        />

                                                        <Divider />

                                                        <CardContent>

                                                            <Grid container spacing={ 3 } mt={ 1 }>

                                                                {
                                                                    edit
                                                                    ?
                                                                        <Grid size={{ md: 12, xs: 12 }}>

                                                                            <FormControl fullWidth>

                                                                                <InputLabel>Autoridad del exhorto</InputLabel>

                                                                                <Select
                                                                                    label="Autoridad del exhorto"
                                                                                    value={ autoridadExhortoRecibido }
                                                                                    onChange={ ( e ) => setAutoridadExhortoRecibido( e.target.value ) }
                                                                                >
                                                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                                                    {
                                                                                        autoridadExhortoRecibidoArray.map( ({ idAutoridadExhortoRecibido, descripcion }) => (
                                                                                            <MenuItem key={ idAutoridadExhortoRecibido } value={ idAutoridadExhortoRecibido }>{ descripcion }</MenuItem>
                                                                                        ))
                                                                                    }

                                                                                </Select>

                                                                            </FormControl>

                                                                        </Grid>
                                                                    :
                                                                        <>
                                                                            <Grid size={{ md: 6, xs: 12 }}>

                                                                                <InfoField
                                                                                    chip
                                                                                    label="Autoridad del exhorto"
                                                                                    value={ acuerdo.exhortoRecibido.autoridadExhortoRecibido }
                                                                                />

                                                                            </Grid>

                                                                            <Grid size={{ md: 6, xs: 12 }}> </Grid>
                                                                        </>
                                                                }

                                                                <Grid size={{ md: 6, xs: 12 }}>

                                                                    {
                                                                        edit
                                                                        ?
                                                                            <FormControl fullWidth>

                                                                                <InputLabel>Objeto del exhorto</InputLabel>

                                                                                <Select
                                                                                    label="Objeto del exhorto"
                                                                                    value={ objetoExhorto }
                                                                                    onChange={ ( e ) => setObjetoExhorto( e.target.value ) }
                                                                                >
                                                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                                                    {
                                                                                        objetoExhortoArray.map( ({ idObjetoExhorto, descripcion }) => (
                                                                                            <MenuItem key={ idObjetoExhorto } value={ idObjetoExhorto }>{ descripcion }</MenuItem>
                                                                                        ))
                                                                                    }

                                                                                </Select>

                                                                            </FormControl>
                                                                        :
                                                                            <InfoField
                                                                                chip
                                                                                label="Objeto del exhorto"
                                                                                value={ acuerdo.exhortoRecibido.objetoExhorto }
                                                                            />
                                                                    }

                                                                </Grid>

                                                                <Grid size={{ md: 6, xs: 12 }}>

                                                                    {
                                                                        edit
                                                                        ?
                                                                            <FormControl fullWidth>

                                                                                <InputLabel>Clase del exhorto</InputLabel>

                                                                                <Select
                                                                                    label="Clase del exhorto"
                                                                                    value={ claseExhorto }
                                                                                    onChange={ ( e ) => setClaseExhorto( e.target.value ) }
                                                                                >
                                                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                                                    {
                                                                                        claseExhortoArray.map( ({ idClaseExhorto, descripcion }) => (
                                                                                            <MenuItem key={ idClaseExhorto } value={ idClaseExhorto }>{ descripcion }</MenuItem>
                                                                                        ))
                                                                                    }

                                                                                </Select>

                                                                            </FormControl>
                                                                        :
                                                                            <InfoField
                                                                                chip
                                                                                label="Clase del exhorto"
                                                                                value={ acuerdo.exhortoRecibido.claseExhorto }
                                                                            />
                                                                    }

                                                                </Grid>

                                                            </Grid>

                                                        </CardContent>

                                                    </Card>

                                                </Grid>
                                        }

                                        {/* Esta información es para un amparo */}

                                        {
                                            (
                                                tabValidation.idPromocion !== 0 &&
                                                tabValidation.idAmparo !== 0
                                            )
                                            &&
                                                <Grid size={{ md: 12, xs: 12 }}>

                                                    <Card>

                                                        <CardHeader
                                                            sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                                                            subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Información del amparo </Typography> }
                                                        />

                                                        <Divider />

                                                        <CardContent>

                                                            <Grid container spacing={ 3 } mt={ 1 }>

                                                                {
                                                                    edit
                                                                    ?
                                                                        <Grid size={{ md: 12, xs: 12 }}>

                                                                            <LocalizationProvider dateAdapter={ AdapterMoment } adapterLocale="es">

                                                                                <DatePicker
                                                                                    label="Fecha resolución"
                                                                                    sx={{ width: '100%' }}
                                                                                    value={ moment( fechaResolucion ) }
                                                                                    minDate={ moment( new Date() ) }
                                                                                    onChange={ (e) => setFechaResolucion( moment( e ).format( 'YYYY-MM-DD' ) ) }
                                                                                />

                                                                            </LocalizationProvider>

                                                                        </Grid>
                                                                    :
                                                                        <Grid size={{ md: 6, xs: 12 }}>

                                                                            <InfoField
                                                                                chip
                                                                                label="Fecha resolución"
                                                                                value={ acuerdo.fechaResolucionAmparo ? moment( acuerdo.fechaResolucionAmparo ).format( 'DD-MM-YYYY' ) : '' }
                                                                            />

                                                                        </Grid>
                                                                }

                                                            </Grid>

                                                        </CardContent>

                                                    </Card>

                                                </Grid>
                                        }

                                        {/* Esta información es para cambiar etapa cuando el amparo cumple  */}

                                        {
                                            (
                                                tabValidation.idAmparo !== 0 &&
                                                subTipoAcuerdo === 16
                                            )
                                            &&
                                                <Grid size={{ md: 12, xs: 12 }}>

                                                    <Card>

                                                        <CardHeader
                                                            sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                                                            subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Cambiar etapa </Typography> }
                                                        />

                                                        <Divider />

                                                        <CardContent>

                                                            <Grid container spacing={ 3 } mt={ 1 }>

                                                                <Grid size={{ md: 6, xs: 12 }}>

                                                                    {
                                                                        edit
                                                                        ?
                                                                            <FormControl fullWidth>

                                                                                <InputLabel>Etapa</InputLabel>

                                                                                <Select
                                                                                    label="Etapa"
                                                                                    value={ etapa }
                                                                                    onChange={ (e) => { setSubEtapa( 0 ); setEtapa( e.target.value );  }}
                                                                                >

                                                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                                                    {
                                                                                        etapaArray
                                                                                        .filter( ({ idEtapa }) => idEtapa !== 14 && idEtapa !== 16 && idEtapa !== 17 && idEtapa !== 18 )
                                                                                        .map( ({ idEtapa, descripcion }) => (
                                                                                            <MenuItem key={ idEtapa } value={ idEtapa }>{ descripcion }</MenuItem>
                                                                                        ))
                                                                                    }

                                                                                </Select>

                                                                            </FormControl>
                                                                        :
                                                                            <InfoField
                                                                                chip
                                                                                label="Etapa"
                                                                                value={ acuerdo.etapa }
                                                                            />
                                                                    }

                                                                </Grid>

                                                                <Grid size={{ md: 6, xs: 12 }}>

                                                                    {
                                                                        edit
                                                                        ?
                                                                            <FormControl fullWidth>

                                                                                <InputLabel>SubEtapa</InputLabel>

                                                                                <Select
                                                                                    label="SubEtapa"
                                                                                    value={ subEtapa }
                                                                                    onChange={ (e) => setSubEtapa( e.target.value ) }
                                                                                    disabled={ etapa === 0 || subEtapaArray.length === 0 }
                                                                                >

                                                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                                                    {
                                                                                        subEtapaArray
                                                                                        .filter( ({ idSubEtapa }) => idSubEtapa !== 32 )
                                                                                        .map( ({ idSubEtapa, descripcion }) => (
                                                                                            <MenuItem key={ idSubEtapa } value={ idSubEtapa }>{ descripcion }</MenuItem>
                                                                                        ))
                                                                                    }

                                                                                </Select>

                                                                            </FormControl>
                                                                        :
                                                                            acuerdo.subEtapa
                                                                            &&
                                                                                <InfoField
                                                                                    chip
                                                                                    label="SubEtapa"
                                                                                    value={ acuerdo.subEtapa }
                                                                                />
                                                                    }

                                                                </Grid>

                                                            </Grid>

                                                        </CardContent>

                                                    </Card>

                                                </Grid>
                                        }

                                        {/* Esta información es cuando se solicitara alguna fecha de audiencia  */}

                                        {
                                            (
                                                tabValidation.idAmparo === 0 &&
                                                tabValidation.idExhortoRecibido === 0 &&
                                                (
                                                    ( idUnidad === 1 && acuerdo.expediente.medioPreparatorio && tipoAcuerdo !== 0 ) ||
                                                    ( [ 2, 5 ].includes( idUnidad ) && tipoAcuerdo === 17 ) ||
                                                    ( idUnidad === 3 && ( acuerdo.expediente.incidente || interponeIncidente || tipoAcuerdo === 13 ) )
                                                )
                                            )
                                            ?
                                                ( edit || acuerdo.oficioso )
                                                ?
                                                    <Grid size={{ md: 12, xs: 12 }}>

                                                        <FormControl fullWidth disabled={ citaSentencia }>

                                                            <Grid container spacing={ 3 }>

                                                                <Grid size={{ md: 6, xs: 12 }} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} >
                                                                    <FormLabel sx={{ color: 'black' }} >¿Desea solicitar fecha de audiencia?</FormLabel>
                                                                </Grid>

                                                                <Grid size={{ md: 6, xs: 12 }} >

                                                                    <RadioGroup row >

                                                                        <Grid container >

                                                                            <Grid size={{ md: 6, xs: 6 }}>
                                                                                <FormControlLabel value="Si" control={ <Radio checked={ solicitarFechaAudiencia } onChange={ () => { setSolicitarFechaAudiencia( true ); setPromocionIrregular( false ); setCitaSentencia( false ); setTipoSentencia( 0 ); }} /> } label="Si" />
                                                                            </Grid>

                                                                            <Grid size={{ md: 6, xs: 6 }}>
                                                                                <FormControlLabel value="No" control={ <Radio checked={ !solicitarFechaAudiencia } onChange={ () => { setSolicitarFechaAudiencia( false ); setTipoAudiencia(0); setPromocionIrregular( false ); }} /> } label="No" />
                                                                            </Grid>

                                                                        </Grid>

                                                                    </RadioGroup>

                                                                </Grid>

                                                            </Grid>

                                                        </FormControl>

                                                    </Grid>
                                                :
                                                    solicitarFechaAudiencia
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>

                                                            <InfoField
                                                                chip
                                                                label="¿Desea solicitar fecha de audiencia?"
                                                                value={ solicitarFechaAudiencia ? 'Si' : 'No' }
                                                            />

                                                        </Grid>
                                            : null
                                        }

                                        {
                                            solicitarFechaAudiencia
                                            &&
                                                <Grid size={{ md: 12, xs: 12 }}>

                                                    <Card>

                                                        <CardHeader
                                                            sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                                                            subheader={
                                                                <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}>
                                                                    { edit ? 'Solicitar fecha de audiencia' : 'Información de la audiencia' }
                                                                </Typography>
                                                            }
                                                        />

                                                        <Divider />

                                                        <CardContent>

                                                            <Grid container spacing={ 3 } mt={ 1 } alignItems="center">

                                                                {
                                                                    ( edit || acuerdo.oficioso )
                                                                    ?
                                                                        <Grid size={{ md: ( tipoAudiencia !== 0 && agregarDuracion ) ? 4 : 6, xs: 12 }}>

                                                                            <FormControl fullWidth>

                                                                                <InputLabel>Tipo de audiencia</InputLabel>

                                                                                <Select
                                                                                    label="Tipo de audiencia"
                                                                                    value={ tipoAudiencia }
                                                                                    onChange={ (e) => {

                                                                                        const id = e.target.value;

                                                                                        setTipoAudiencia( id );

                                                                                        const tipoAudienciaFound = tipoAudienciaArray.find( ({ idTipoAudiencia }) => idTipoAudiencia === id );

                                                                                        setDuracionAudiencia( tipoAudienciaFound?.duracion ?? 30 );
                                                                                    }}
                                                                                    disabled={ solicitarFechaAudiencia && audiencia.idSecretario !== 0 }
                                                                                >

                                                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>

                                                                                    {
                                                                                        tipoAudienciaArray
                                                                                        .filter( ta => {

                                                                                           if ( idUnidad === 1 && acuerdo.expediente.medioPreparatorio ) {
                                                                                                return ta.medioPreparatorio === true;
                                                                                            }

                                                                                            if (( idUnidad === 2 || idUnidad === 5 ) && ( acuerdo.expediente.idTipoJuicio === 1 || acuerdo.expediente.idTipoJuicio === 2 )) {
                                                                                                return ta.tradicional === true && ta.idTipoAudiencia !== 4 && ta.idTipoAudiencia !== 15;
                                                                                            }

                                                                                            if (( idUnidad === 2 || idUnidad === 5 ) && ( acuerdo.expediente.idTipoJuicio === 3 || acuerdo.expediente.idTipoJuicio === 4 )) {
                                                                                                return ta.oral === true && ta.idTipoAudiencia !== 4 && ta.idTipoAudiencia !== 15;
                                                                                            }

                                                                                            if ( idUnidad === 3 && ( acuerdo.expediente.incidente || interponeIncidente ) ) {
                                                                                                return ta.idTipoAudiencia === 15;
                                                                                            }

                                                                                            if ( idUnidad === 3 && tipoAcuerdo === 13 ) {
                                                                                                return ta.idTipoAudiencia === 4;
                                                                                            }

                                                                                            return false;
                                                                                        })
                                                                                        .map(({ idTipoAudiencia, descripcion }) => (
                                                                                            <MenuItem key={ idTipoAudiencia } value={ idTipoAudiencia }>
                                                                                                { descripcion }
                                                                                            </MenuItem>
                                                                                        ))
                                                                                    }

                                                                                </Select>

                                                                            </FormControl>

                                                                            {
                                                                                tipoAudiencia !== 0
                                                                                &&
                                                                                    <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
                                                                                        <Typography sx={{ fontSize: 14, color: 'text.secondary' }}>¿Desea agregar duración a esta audiencia?</Typography>
                                                                                        <RadioGroup row>
                                                                                            <FormControlLabel value="Si" control={ <Radio disabled={ solicitarFechaAudiencia && audiencia.idSecretario !== 0 } checked={ agregarDuracion } onChange={ () => setAgregarDuracion( true ) } /> } label={ <Typography>Si</Typography> } />
                                                                                            <FormControlLabel value="No" control={ <Radio disabled={ solicitarFechaAudiencia && audiencia.idSecretario !== 0 } checked={ !agregarDuracion } onChange={ () => setAgregarDuracion( false ) } /> } label={ <Typography>No</Typography> } />
                                                                                        </RadioGroup>
                                                                                    </Box>
                                                                            }

                                                                        </Grid>
                                                                    :
                                                                        <Grid size={{ md: 6, xs: 12 }}>

                                                                            <InfoField
                                                                                chip
                                                                                label="Tipo de audiencia"
                                                                                value={ audiencia.tipoAudiencia }
                                                                            />

                                                                        </Grid>
                                                                }

                                                                {
                                                                    ( tipoAudiencia !== 0 && ( edit || acuerdo.oficioso ) && agregarDuracion )
                                                                    &&
                                                                        <Grid size={{ md: 2, xs: 12 }}>

                                                                            <TextField
                                                                                label='Duración(Minutos)'
                                                                                type="number"
                                                                                value={ duracionAudiencia }
                                                                                slotProps={{ htmlInput: { min: tipoAudienciaArray.find(({ idTipoAudiencia }) => idTipoAudiencia === tipoAudiencia)?.duracion ?? 30 } }}
                                                                                disabled={ solicitarFechaAudiencia && audiencia.idSecretario !== 0 }
                                                                                onChange={ (e) => setDuracionAudiencia( Number( e.target.value ) ) }
                                                                                onBlur={ (e) => {
                                                                                    const min = tipoAudienciaArray.find(({ idTipoAudiencia }) => idTipoAudiencia === tipoAudiencia)?.duracion ?? 30;
                                                                                    if ( Number( e.target.value ) < min ) setDuracionAudiencia( min );
                                                                                }}
                                                                            />

                                                                        </Grid>
                                                                }

                                                                {
                                                                    ( edit || acuerdo.oficioso )
                                                                    &&
                                                                        <Grid size={{ md: 3, xs: 12 }}>

                                                                            <Button
                                                                                fullWidth
                                                                                variant='contained'
                                                                                startIcon={ <CalendarTodayIcon /> }
                                                                                onClick={ () => setOpenDialogSolicitarFechaAudiencia( true ) }
                                                                                disabled={ tipoAudiencia === 0 || ( solicitarFechaAudiencia && audiencia.idSecretario !== 0 ) }
                                                                            >
                                                                                Solicitar fecha de audiencia
                                                                            </Button>

                                                                        </Grid>
                                                                }

                                                                <Grid size={{ md: edit ? 3 : 6, xs: 12 }}>

                                                                    {
                                                                        audiencia.idSecretario !== 0
                                                                        &&
                                                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, textAlign: 'center' }}>

                                                                                <Typography variant="body1" color="text.secondary">
                                                                                    Fecha de audiencia:
                                                                                </Typography>

                                                                                <Typography variant="body1" fontWeight="bold">
                                                                                    { moment( audiencia.fechaInicio ).format('DD-MM-YYYY') } { moment( audiencia.fechaInicio ).format('HH:mm') } - { moment( audiencia.fechaFin ).format('HH:mm') }
                                                                                </Typography>

                                                                                <Typography variant="body2" color="text.secondary">
                                                                                    { audiencia.sala }
                                                                                </Typography>

                                                                            </Box>
                                                                    }

                                                                </Grid>

                                                            </Grid>

                                                        </CardContent>

                                                    </Card>

                                                </Grid>
                                        }

                                        {/* ---------------------------------------------------------------------------------------------- */}

                                        <Grid size={{ md: 12, xs: 12 }}>

                                            <FormControl fullWidth>

                                                <InputLabel>Plantilla(s)</InputLabel>

                                                <Select
                                                    label="Plantilla(s)"
                                                    value={ plantilla }
                                                    onChange={ (e) => obtenerPlantilla( e.target.value ) }
                                                >
                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                    {
                                                        plantillaArray.map( ({ idPlantilla, descripcion }) => (
                                                            <MenuItem key={ idPlantilla } value={ idPlantilla }>{ descripcion }</MenuItem>
                                                        ))
                                                    }
                                                </Select>

                                            </FormControl>

                                        </Grid>

                                        <Grid size={{ md: 12, xs: 12 }}>

                                            <DocumentEditorContainerComponent
                                                key='DocumentEditorContainer'
                                                serviceUrl={ process.env.REACT_APP_URL_SERVICE_DOCUMENT_EDITOR ?? '' }
                                                height='650'
                                                ref={ syncfusionEditor }
                                                enableToolbar={ true }
                                                showPropertiesPane={ false }
                                                toolbarItems={ Toolbar }
                                                autoResizeOnVisibilityChange={ false }
                                                created={ handleEditorCreated }
                                            >
                                            </DocumentEditorContainerComponent>

                                        </Grid>

                                        {
                                            acuerdo.observaciones
                                            &&
                                                <Grid size={{ xs: 12, md: 12 }}>

                                                    <Card sx={{ p: 2 }}>

                                                        <Typography variant="h6" sx={{ mb: 2 }}>
                                                            Observaciones
                                                        </Typography>

                                                        <Stack spacing={ 2 }>

                                                            {
                                                                observaciones.map( ( { usuario, puesto, observacion, fecha }, i ) => (

                                                                    <Box key={ i } sx={{ display: "flex", gap: 1.5, alignItems: "flex-start" }}>

                                                                        <Avatar
                                                                            sx={{
                                                                                width: 36,
                                                                                height: 36,
                                                                                fontSize: 12,
                                                                                fontWeight: 500,
                                                                                bgcolor: (theme) => theme.palette.primary.main,
                                                                                color: 'white',
                                                                            }}
                                                                        >
                                                                            { usuario.split(" ").slice(0, 2).map(n => n[0]).join("") }
                                                                        </Avatar>

                                                                        <Box
                                                                            sx={{
                                                                                flex: 1,
                                                                                bgcolor: "action.hover",
                                                                                border: "0.5px solid",
                                                                                borderColor: "divider",
                                                                                borderRadius: "0 15px 15px 15px",
                                                                                px: 2,
                                                                                py: 1.25,
                                                                            }}
                                                                        >
                                                                            <Typography variant="subtitle2" fontWeight={ 500 }>
                                                                                { usuario } { puesto ? `(${ puesto })` : '' }
                                                                            </Typography>

                                                                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, lineHeight: 1.5 }}>
                                                                                { observacion }
                                                                            </Typography>

                                                                            {
                                                                                fecha
                                                                                &&
                                                                                    <Typography variant="caption" color="text.disabled" sx={{ mt: 0.75, display: "block" }}>
                                                                                    {  fecha ? moment( fecha ).format('DD-MM-YYYY hh:mm a') : '' }
                                                                                    </Typography>

                                                                            }

                                                                        </Box>

                                                                    </Box>

                                                                ))
                                                            }

                                                        </Stack>

                                                        </Card>

                                                </Grid>
                                        }

                                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                                            <Grid container spacing={ 3 }>

                                                {
                                                    !acuerdo.oficioso
                                                    &&
                                                        <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'right'}}>

                                                            <Button
                                                                fullWidth
                                                                color='secondary'
                                                                loading={ loadingRegresar }
                                                                onClick={ handleRegresar }
                                                            >
                                                                Regresar a calificar trámite
                                                            </Button>

                                                        </Grid>
                                                }

                                                <Grid size={{ md: !acuerdo.oficioso ? 4 : 6, xs: 12 }} sx={{ textAlign: 'right'}}>

                                                    <Button
                                                        fullWidth
                                                        color='secondary'
                                                        variant="outlined"
                                                        loading={ loadingGuardar }
                                                        onClick={ handleGuardar }
                                                    >
                                                        Guardar
                                                    </Button>

                                                </Grid>

                                                <Grid size={{ md: !acuerdo.oficioso ? 4 : 6, xs: 12 }} style={{ textAlign: 'left' }}>
                                                    <Button
                                                        fullWidth
                                                        color='primary'
                                                        variant="contained"
                                                        onClick={ handleConfirmacion }
                                                    >
                                                        Finalizar
                                                    </Button>
                                                </Grid>

                                            </Grid>

                                        </Grid>

                                    </Grid>

                                </Box>

                            </TabPanel>

                            <TabPanel value={ value } index={ 1 }>

                                <Notificacion
                                    acuerdo={ acuerdo }
                                    notificaciones={ notificaciones }
                                    setNotificaciones={ setNotificaciones }
                                />

                            </TabPanel>

                            <TabPanel value={ value } index={ 2 }>

                                <BoxInformacionPromocion
                                    promocion={ acuerdo.promocion }
                                />

                            </TabPanel>

                            <TabPanel value={ value } index={ 3 }>

                                <BoxInformacionAmparo amparo={ acuerdo.amparo } />

                            </TabPanel>

                            <TabPanel value={ value } index={ 4 }>

                                <BoxInformacionExpediente
                                    expediente={ acuerdo.expediente }
                                    demandaInicial={ acuerdo.demandaInicial }
                                />

                            </TabPanel>

                            <TabPanel value={ value } index={ 5 }>

                                <BoxInformacionExhortoRecibido
                                    exhortoRecibido={ acuerdo.exhortoRecibido }
                                />

                            </TabPanel>

                            <TabPanel value={ value } index={ 6 }>

                                <BoxInformacionIrregular irregular={ acuerdo.irregular } />

                            </TabPanel>

                    </>
            }

            <DialogDocumento
                openDialog={ openDocumento }
                handleCloseDialog={ () => setOpenDocumento( false ) }
                documento={ documento }
            />

            <DialogPartesAcuerdo
                idAcuerdo={ acuerdo.idAcuerdo }
                openDialog={ openPartesIrregular }
                handleCloseDialog={ () => setOpenPartesIrregular( false ) }
                edit={ false }
            />

            <Dialog
                fullWidth
                maxWidth='sm'
                open={ openDialogSolicitarFechaAudiencia }
                onClose={ () => {} }
            >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent>

                    <DialogContentText>
                       ¿Desea solicitar fecha de <strong> { tipoAudienciaArray.find( ({ idTipoAudiencia }) => idTipoAudiencia === tipoAudiencia )?.descripcion } </strong>?
                    </DialogContentText>

                </DialogContent>

                <DialogActions>

                    <Button color="secondary" disabled={ loadingSolicitarFechaAudiencia } onClick={ () => { setOpenDialogSolicitarFechaAudiencia( false ); } }> Cancelar </Button>

                    <Button
                        variant='contained'
                        onClick={ handleSolicitarFechaAudiencia }
                        loading={ loadingSolicitarFechaAudiencia }
                    >
                        Aceptar
                    </Button>

                </DialogActions>

            </Dialog>

            <Dialog
                maxWidth='sm'
                fullWidth
                open={ openConfirmacion }
                onClose={ () => {} }
            >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent>

                    <DialogContentText>
                        ¿Desea finalizar la elaboración del acuerdo?
                    </DialogContentText>

                </DialogContent>

                <DialogActions>
                    <Button color='secondary' disabled={ loadingFinalizar } onClick={ () => setOpenConfirmacion( false ) }> Cancelar </Button>
                    <Button loading={ loadingFinalizar } onClick={ handleFinalizar } variant='contained' > Aceptar </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                fullWidth
                maxWidth="sm"
                open={ openResoluciones }
                onClose={ () => {} }
            >

                <DialogTitle>
                    Resolución(es)
                </DialogTitle>

                <DialogContent>

                    {
                        resoluciones?.length === 0
                        &&
                            <Box textAlign='center' py={ 4 }>

                                <Typography variant="caption" color="text.secondary">
                                    No se encontraron registros
                                </Typography>

                            </Box>
                    }

                    <List disablePadding sx={{ maxHeight: 600 }}>

                        {
                            resoluciones?.map( ( elem, i ) => (

                                <Box key={ i } sx={{
                                    p: 2,
                                    mb: 1,
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    '&:hover': { backgroundColor: 'action.hover' }
                                }}>

                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>

                                        <Box>

                                            <Typography variant='subtitle1' fontWeight='bold'>
                                                { elem.tipoAcuerdo }
                                            </Typography>

                                            <Typography variant='body2' color='text.secondary'>
                                                { elem.subTipoAcuerdo }
                                            </Typography>

                                        </Box>

                                        <Typography variant='caption' color='text.secondary' sx={{ whiteSpace: 'nowrap', ml: 2 }}>
                                            { elem.fecha ? moment( elem.fecha ).format('DD-MM-YYYY HH:mm a') : '' }
                                        </Typography>

                                    </Box>

                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1.5 }}>

                                        <Button
                                            color="secondary"
                                            size='small'
                                            onClick={ () => { setDocumento( elem.url ); setOpenDocumento( true ); } }
                                        >
                                            Ver documento
                                        </Button>

                                        {
                                            edit
                                            &&
                                                <Button
                                                    size='small'
                                                    variant='contained'
                                                    onClick={ () =>{
                                                        setMedioImpugnacion({ ...medioImpugnacion, idReferencia: elem.id, medioImpugnacionDocumento: elem, });
                                                        setOpenResoluciones( false );
                                                    }}
                                                >
                                                    Seleccionar
                                                </Button>
                                        }

                                    </Box>

                                </Box>

                            ))
                        }

                    </List>

                </DialogContent>

                <DialogActions>

                    <Button color="primary" onClick={ () => { setOpenResoluciones( false ); setResoluciones( [] ); } }>
                        Cerrar
                    </Button>

                </DialogActions>

            </Dialog>

        </Layout>
    )
}
